import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import accountResources from "./i18nAccount";
import rankResources from "./i18nRank";

const resources = {
  en: {
    translation: {
      status: {
        live: "Live",
        scheduled: "Scheduled",
        ended: "Ended",
        suspended: "Suspended",
      },
      nav: {
        features: "Features",
        games: "Games",
        pricing: "Pricing",
        login: "Log in",
        login_short: "Log in",
        contact_short: "Contact",
        dashboard: "Dashboard",
        logout: "Log out",
        how: "How it works",
      },
      lp: {
        nav_games: "Games",
        nav_benefits: "Benefits",
        nav_pricing: "Pricing",
        nav_contact: "Contact",
        nav_login: "Log in",
        nav_cta: "Launch a game",
        hero_badge: "QR-code marketing gamification platform",
        hero_title_1: "Turn every visit",
        hero_title_2: "into a loyal customer with",
        hero_title_grad: "Gamification",
        hero_sub_a: "Collect Google reviews, win Instagram followers and capture qualified leads with ",
        hero_sub_bold: "14 premium mini-games",
        hero_sub_b: " fully customised to your brand.",
        hero_cta_primary: "Launch your first game",
        hero_cta_secondary: "Discover the benefits",
        hero_proof_games: "14 premium mini-games",
        hero_proof_unlimited: "Unlimited players",
        hero_proof_fraud: "Anti-fraud & GDPR",
        trust_title: "Brands that trust us",
        games_eyebrow: "The catalogue",
        games_title: "14 premium mini-games, for every occasion.",
        games_sub_a: "Sales, holidays, birthdays, product launches… there is always a game that fits. Each one is customisable: colours, fonts, prizes, odds and sounds. ",
        games_sub_bold: "Click a game to try it in real conditions.",
        game_try: "Try this game",
        game_more_title: "More coming soon…",
        game_more_link: "See pricing",
        game_roue_name: "Spin Wheel", game_roue_desc: "The irresistible classic",
        game_gratter_name: "Scratch Card", game_gratter_desc: "Scratch, win, come back",
        game_slot_name: "Slot Machine", game_slot_desc: "Three symbols, one jackpot",
        game_cartes_name: "Card Game", game_cartes_desc: "Flip the right card",
        game_mystere_name: "Mystery Box", game_mystere_desc: "5 chest styles to open",
        game_tirage_name: "Prize Draw", game_tirage_desc: "One or several winners",
        game_prix_name: "Guess the Price", game_prix_desc: "Guess the product's price",
        game_ninja_name: "Ninja", game_ninja_desc: "Slice your products mid-air",
        game_bougies_name: "Blow the Candles", game_bougies_desc: "Into the mic, like a birthday",
        game_flappy_name: "Flappy Mascot", game_flappy_desc: "Your mascot, their high score",
        game_pronos_name: "Sports Predictions", game_pronos_desc: "Bet on real matches",
        game_penalty_name: "3D Penalty", game_penalty_desc: "Immersive penalty shootout",
        game_cadeau_name: "Sign-up Gift", game_cadeau_desc: "Guaranteed prize on sign-up",
        game_avent_name: "Advent Calendar", game_avent_desc: "One door a day, customers come back",
        game_quiz_name: "Quiz", game_quiz_desc: "Answer right, enter the draw",
        how_eyebrow: "How it works",
        how_title: "From the scan to the return visit, in 4 steps.",
        step1_t: "QR code scan", step1_d: "One permanent QR, printed once, reusable for all your campaigns.",
        step2_t: "Express form", step2_d: "First name, email, phone… you choose the fields. 100% opt-in contacts.",
        step3_t: "Winning actions", step3_d: "11 actions to choose from: Google review, Instagram follow, TikTok, newsletter… before even playing.",
        step4_t: "Game & reward", step4_d: "The customer plays, wins and receives their coupon by email. They come back to spend.",
        ctas_eyebrow: "Winning actions",
        ctas_title: "11 CTAs to choose from, before every play.",
        ctas_sub: "To unlock their entry, the player completes the action of your choice: a review, a follow, a sign-up… Combine as many as you like, they are unlimited.",
        cta_google_review_label: "Google review", cta_google_review_benefit: "Climb local search results and reassure your future customers.",
        cta_instagram_follow_label: "Instagram follow", cta_instagram_follow_benefit: "Gain followers who will see your posts, stories and promotions again.",
        cta_facebook_like_label: "Facebook like", cta_facebook_like_benefit: "Grow your community and the reach of every post.",
        cta_tiktok_follow_label: "TikTok follow", cta_tiktok_follow_benefit: "Reach a young audience and make your videos go viral.",
        cta_youtube_subscribe_label: "YouTube subscribe", cta_youtube_subscribe_benefit: "Build a lasting audience for your video content.",
        cta_linkedin_follow_label: "LinkedIn follow", cta_linkedin_follow_benefit: "Strengthen your professional image and B2B network.",
        cta_tripadvisor_review_label: "Tripadvisor review", cta_tripadvisor_review_benefit: "Attract tourists and visitors who choose based on reviews.",
        cta_instagram_story_label: "Instagram story", cta_instagram_story_benefit: "Your customers become your ambassadors to their friends.",
        cta_app_download_label: "App download", cta_app_download_benefit: "Get your app installed on every player's phone.",
        cta_newsletter_signup_label: "Newsletter sign-up", cta_newsletter_signup_benefit: "Build an opt-in email base you can reactivate at will, at no cost.",
        cta_account_creation_label: "Account creation", cta_account_creation_benefit: "Turn players into registered customers on your website.",
        cta_unlimited_title: "Stackable & unlimited",
        cta_unlimited_desc: "Combine several actions on the same game — no limit, no extra cost.",
        adv_eyebrow: "The benefits",
        adv_title: "Built for merchants, powered by AI.",
        adv_ocr_title: "AI-OCR proof of purchase",
        adv_ocr_desc: "Require a receipt to play: our AI automatically reads the amount, the date and the store name. Zero manual checks, zero fraud.",
        adv_ocr_chip1: "Minimum amount", adv_ocr_chip2: "Receipt age", adv_ocr_chip3: "Store name",
        adv_qr_alt: "Scanning a QR code",
        adv_qr_title: "Permanent QR code",
        adv_qr_desc: "Printed once, it always points to your active game. Switch campaigns without reprinting.",
        adv_custom_title: "Total customisation",
        adv_custom_desc: "13 fonts, colours, backgrounds per device (PC, tablet, mobile), sounds, confetti in your colours… the game becomes an extension of your brand.",
        adv_fraud_title: "Built-in anti-fraud",
        adv_fraud_desc: "One entry per person per game: browser fingerprint, email and phone verified — even in private browsing.",
        adv_email_title: "Automated rewards",
        adv_email_desc: "Coupons emailed automatically, with validity dates, per-prize instructions and your personalised message.",
        adv_turnkey_title: "Turnkey game",
        adv_turnkey_desc: "Our team fully configures your game: prizes, odds, visuals, rules. You receive it ready to launch — all you have to do is display the QR code.",
        adv_lottery_title: "One-click prize draw",
        adv_lottery_desc: "The tool runs your draw: one click and winners are picked randomly and fairly among participants — instant winners list.",
        adv_claims_title: "Managed prize collection",
        adv_claims_desc: "Prize collection is driven by the tool: a unique coupon per winner, in-store validation and real-time tracking of collected or pending prizes.",
        adv_data_title: "Data, analytics & GDPR",
        adv_data_desc: "Entries, winners and remaining stock in real time. Export your opt-in contacts in one click — 100% GDPR compliant, data hosted in Europe.",
        adv_stat1_l: "more Google reviews", adv_stat2_l: "marketing opt-in", adv_stat3_l: "to launch a game",
        opt_eyebrow: "À-la-carte options",
        opt_title: "Every game, your rules.",
        opt_sub_a: "Enable entry conditions and extra fields in one click — available on ",
        opt_sub_bold: "every game",
        opt_sub_b: ", at no extra cost.",
        opt_li1: "Phone required, optional or hidden", opt_li2: "Marketing opt-in consent (GDPR)", opt_li3: "Combinable with each other, game by game",
        opt_mock_title: "Entry conditions",
        opt_receipt_title: "Receipt required",
        opt_receipt_desc: "The participant uploads or photographs their receipt before playing. AI OCR extracts the amount, date and store name for verification.",
        opt_address_title: "Collect postal address",
        opt_address_desc: "Street, postcode, city — ideal when you ship a physical gift: stickers, mugs, t-shirts…",
        opt_birthdate_title: "Ask for date of birth",
        opt_birthdate_desc: "Enrich your contacts and trigger personalised birthday campaigns.",
        ben_google_title: "Boost your Google reviews",
        ben_google_desc: "Ask for a review before every play. Our merchants multiply their reviews by 5 in the first month — and climb local results.",
        ben_google_cta: "Collect more reviews",
        ben_sales_title: "Generate more sales",
        ben_sales_desc: "Every winner receives a coupon to redeem in store. The game creates traffic, the coupon creates the checkout.",
        ben_sales_cta: "Bring my customers back",
        ben_contacts_title: "Capture qualified leads",
        ben_contacts_desc: "First name, email, phone, marketing consent: build a local, reactivable contact base, campaign after campaign.",
        ben_contacts_cta: "Build my customer base",
        price_eyebrow: "Pricing",
        price_title: "Simple pricing, immediate ROI.",
        price_sub: "Pay per game, not per participant. Whatever your traffic, the price stays the same.",
        price_recommended: "Recommended",
        price_plan1: "With commitment",
        price_unit: "excl. VAT / game",
        price_plan1_desc_a: "Up to 1 month per game, subject to a commitment of ",
        price_plan1_desc_bold: "at least 4 games per year",
        price_plan1_cta: "Commit and save 50%",
        price_plan2: "No commitment — One Shot",
        price_plan2_desc_a: "Up to 1 month per game. ",
        price_plan2_desc_bold: "No commitment",
        price_plan2_desc_b: ": ideal to test or for a one-off operation.",
        price_plan2_cta: "Launch a One Shot game",
        price_b1: "Unlimited participants", price_b2: "Unlimited games", price_b3: "Unlimited CTAs", price_b4: "Advanced analytics",
        price_footnote: "Unlimited participants, games and CTAs on both plans. Prices exclude VAT.",
        contact_eyebrow: "Contact",
        contact_title: "Let's talk about your project.",
        contact_sub: "A question about the games, pricing or a custom operation? Write to us — we reply within 24 business hours.",
        contact_li1: "Personalised platform demo", contact_li2: "Support launching your 1st game", contact_li3: "Quote for multi-store operations",
        contact_success_title: "Message sent!",
        contact_success_body: "Thank you {{name}}, we'll get back to you very soon at {{email}}.",
        contact_ph_name: "Your name *", contact_ph_email: "Your email *", contact_ph_company: "Company (optional)", contact_ph_phone: "Phone (optional)", contact_ph_message: "Your message *",
        contact_sending: "Sending…", contact_send: "Send message",
        contact_privacy: "Your data is only used to reply to you. Never shared.",
        contact_err_required: "Name, email and message are required.",
        contact_err_generic: "Something went wrong. Please try again in a moment.",
        final_title_1: "Your next customer is already",
        final_title_2: "in front of your ",
        final_title_grad: "QR code",
        final_sub: "Launch your first game in minutes. Unlimited participants, total customisation, measurable results from the first week.",
        final_cta: "Get started now",
        footer_login: "Log in",
        footer_copy: "QRISE — qrise-game.fr · Data hosted in Europe · GDPR",
        footer_legal: "Legal notice", footer_terms: "Terms of use", footer_cgv: "Terms of sale", footer_privacy: "Privacy policy",
        footer_publisher: "QRISE is published by DEAL RUN — SARL · SIREN 895 350 783",
        lang_label: "Language",
      },

      landing: {
        // Legacy keys kept for any other screens still using them
        badge: "Gamification that converts",
        title_a: "Turn every scan into a",
        title_b: "loyal customer",
        subtitle:
          "QRISE lets businesses launch premium interactive games to capture leads, boost reviews and grow social reach.",
        stats_plays: "Plays delivered",
        stats_conv: "Avg. conversion",
        stats_brands: "Brands trust QRISE",
        // New premium landing
        eyebrow: "QRISE · GAMIFIED COMMERCE ENGINE",
        learn_more: "Learn more",
        try_demo: "Try the demo",
        book_demo: "Book my demo",
        see_terms: "Read the terms",
        see_features: "See features",
        promo_text: "Boost your conversion by 38% — book your live demo today.",
        promo_cta: "Book a demo",
        apple_hero_title_v2: "Your customers play.",
        apple_hero_title_v2_2: "You get paid.",
        apple_hero_sub_v2: "11 interactive games. 11 marketing objectives. One permanent QR code.",
        apple_hero_sub_v2_2: "+38% conversion · 87% email open rate · live in under 60 seconds.",
        hero_proof_1: "No commitment",
        hero_proof_2: "No credit card",
        hero_proof_3: "15-minute demo",
        apple_hero_title: "QRISE",
        apple_hero_sub: "Eleven games. One QR code. +38% conversion guaranteed.",
        apple_hero_tile_title_v2: "The Wheel that pays.",
        apple_hero_tile_sub_v2: "Triple your daily traffic. Capture 100% of the leads.",
        apple_hero_tile_title: "Spin Wheel",
        apple_hero_tile_sub: "Triple your daily traffic with a single permanent QR code.",
        ctas_title_v2: "One game = one marketing objective.",
        ctas_sub_v2: "Gate participation behind a like, a review, a follow or a download. Every play becomes a growth lever.",
        ctas_group_social: "Social networks",
        ctas_group_reviews: "Reviews & reputation",
        ctas_group_growth: "Acquisition & growth",
        cta_facebook_like_sales: "Multiply your community of fans.",
        cta_instagram_follow_sales: "Convert visits into IG followers.",
        cta_instagram_story_sales: "Earn massive UGC reach in 24h.",
        cta_tiktok_follow_sales: "Tap into Gen Z and viral discovery.",
        cta_youtube_subscribe_sales: "Build your YouTube audience effortlessly.",
        cta_linkedin_follow_sales: "Power up your B2B brand recognition.",
        cta_google_review_sales: "Climb local search rankings. Each star = +9% conversion.",
        cta_tripadvisor_review_sales: "Dominate the tourist sector. Get 5-star reviews on demand.",
        cta_newsletter_signup_sales: "Build a contactable, profitable database.",
        cta_account_creation_sales: "Convert visitors into recognised customers, not anonymous traffic.",
        cta_app_download_sales: "Multiply mobile installs without ad spend.",
        marquee_eyebrow: "240+ MERCHANTS ALREADY TRUST US",
        testi_eyebrow: "THEY SAY IT BETTER THAN WE DO",
        testi_title: "Merchants who stopped paying for ads.",
        testi1_q: "We doubled our Google reviews in 6 weeks. Customers love the animation and come back to play every week.",
        testi2_q: "Our checkout QR code brings us 200+ newsletter signups per month. No effort, no ad budget.",
        testi3_q: "The Mystery Box exploded our Instagram engagement. +47% followers in two months.",
        cta_guarantee_badge: "100% SATISFIED — OR YOUR MONEY BACK",
        apple_cta_title_v2: "Your competitors are already playing.",
        apple_cta_title_v2_2: "Are you?",
        apple_cta_sub_v2: "+38% conversion in a 15-minute demo. No commitment, no card, no surprise.",
        cta_proof_1: "Live in under 60 seconds",
        cta_proof_2: "GDPR compliant",
        cta_proof_3: "Bilingual EN / FR",
        apple_mystery_sub: "87% open rate. The mechanic that turns scans into qualified leads.",
        apple_scratch_sub: "Up to 5 minutes engagement. Premium feel that lifts perceived value.",
        apple_antireplay_sub: "Triple guard on device, phone and email. Zero fraud, zero loss.",
        apple_receipts_sub: "GPT-Vision validates each receipt server-side. Out-of-policy tickets auto-rejected.",
        apple_flappy_sub: "The tournament that brings them back every day. Custom mascot, live leaderboard.",
        apple_mobile_sub: "Works flawlessly inside Facebook & Instagram in-app browsers. 100% completion.",
        apple_analytics_sub: "Real-time dashboard. Conversions, redemptions, ROI — all on one screen.",
        apple_exports_sub: "True XLSX in one click. Drop into your CRM, no plumbing required.",
        apple_cta_title: "Get started today.",
        apple_cta_sub: "+38% conversion in a 15-minute demo. No commitment, no card.",
        all_games_title: "Eleven games. One platform.",
        all_games_sub: "Pick the mechanic that fits your brand and launch in minutes.",
        stat_conv_label_long: "average conversion lift",
        stat_games_label_long: "playable mechanics",
        stat_plays_label_long: "plays delivered",
        stat_setup_label_long: "to launch a game",
        sales_spin_wheel_desc: "Visual drama at every spin. Players stay 3× longer.",
        sales_mystery_box_desc: "6-digit code by email. 87% open rate.",
        sales_scratch_card_desc: "Tactile reveal. Premium feel, low cost per play.",
        sales_lottery_draw_desc: "Big-ticket wins, viral referral mechanic baked in.",
        sales_slot_machine_desc: "Three reels of pure dopamine. Instant winner reveal.",
        sales_ninja_desc: "Skill-based slicing. Perfect for tournament campaigns.",
        sales_flappy_mascotte_desc: "Daily streak loops. Bring them back every day.",
        sales_blow_candles_desc: "Real-mic blowing. The wow factor at birthdays.",
        sales_card_game_desc: "Memory match. Cognitive engagement, low fatigue.",
        sales_prediction_match_desc: "Live sports pronostics. Spike traffic before kickoff.",
        sales_guess_price_desc: "Closest-to-the-pin. Instant lead-qualification mechanic.",
        hero_eyebrow: "PREMIUM GAMIFICATION COMMERCE",
        hero_overline: "QRISE / GAMIFICATION OS",
        hero_title_a: "We've reinvented",
        hero_title_b: "loyalty",
        hero_title_dot: ".",
        hero_title_c: "Through play.",
        hero_scroll: "Scroll to explore",
        trust_eyebrow: "TRUSTED BY OPERATORS",
        benefit1: "for maximum, automated engagement.",
        benefit1_bold: "A single platform",
        benefit1_desc:
          "Eleven game mechanics, one permanent QR code per merchant. Triple-guard anti-replay on device, phone and email. GPT-Vision OCR validates each receipt server-side. Every play is scored, attributed and exported in seconds.",
        benefit2: "scalable operation.",
        benefit2_bold: "Easy",
        benefit2_desc:
          "Designed for disruption-free merchant onboarding. Branded reward emails delivered in seconds via Resend, masked GDPR-safe exports, signed contract download, bilingual FR/EN, mobile-first canvas — Facebook in-app browser blocker included.",
        benefit3: "repeatable ROI.",
        benefit3_bold: "Rapid,",
        benefit3_desc:
          "Real Excel exports, real-time analytics dashboard, viral CTAs (follow, review, share) gated by mechanic. Ready to deploy on day one, scales across hundreds of merchant locations without operational overhead.",
        os_eyebrow: "That's the",
        os_title: "QRISE OS",
        stat_games_label: "GAMES",
        stat_plays_label: "PLAYS",
        stat_conv_label: "CONV %",
        games_title_a: "Eleven mechanics.",
        games_title_b: "One playbook.",
        features_title_a: "Built for operators.",
        features_title_b: "Loved by players.",
        benefits_title_a: "An intelligent bridge",
        benefits_title_b: "seamlessly connecting",
        benefits_title_c: "checkout to delight",
        final_title_a: "Reach out",
        final_title_b: "On your terms.",
        hero_line1: "Make every scan",
        hero_line2_italic: "a winning play.",
        hero_line2_bold: "a winning play",
        hero_sub:
          "Eleven high-end interactive games, one permanent QR code. Capture qualified leads, reward your best customers, and turn every checkout into a stage.",
        hero_cta_primary: "Contact us",
        hero_cta_secondary: "Play the live demo",
        hero_badge: "Live · 1,204 plays in the last hour",
        final_eyebrow: "READY TO PLAY",
        final_title: "Make every scan",
        final_title_italic: "a memorable play.",
        final_title_bold: "today.",
        final_sub:
          "A 15-minute live demo, no commitment.",
        stat_plays: "Plays delivered",
        stat_conv: "Avg. conversion",
        stat_brands: "Brands onboard",
        features_eyebrow: "§ 03 — PRODUCT",
        features_title: "Polished mechanics. Serious results.",
        features_sub:
          "Eleven mechanics, a granular CTA system, real-time analytics — built for operators who care about finish.",
        feat_setup_title: "Launch in minutes",
        feat_setup_desc:
          "Design segments, rewards and CTAs from a pristine admin. Ship a permanent QR per merchant in one click.",
        feat_receipts_title: "Receipt OCR proof",
        feat_receipts_desc:
          "Players upload their till receipt — GPT-Vision OCR extracts amount, date, merchant and rejects out-of-policy tickets server-side.",
        feat_antireplay_title: "Anti-replay & GDPR",
        feat_antireplay_desc:
          "Triple guard on device + phone + email per game, signed RGPD contract download, masked exports for unsubscribed leads.",
        feat_branded_email_title: "Branded reward emails",
        feat_branded_email_desc:
          "Editorial Resend templates with merchant logo, instant delivery, transactional headers — winners get the prize in seconds.",
        feat_exports_title: "Real Excel exports",
        feat_exports_desc:
          "One-click XLSX with participant info, CTAs completed, receipt OCR fields and redemption status — never CSV-only.",
        feat_bilingual_title: "Bilingual FR / EN",
        feat_bilingual_desc:
          "Every game, email, legal page and admin screen ships in both languages with the same one-click toggle.",
        feat_targeting_title: "Qualified lead capture",
        feat_targeting_desc:
          "Name, email, phone required before play. GDPR opt-in, masked exports, clean CSV and XLSX.",
        feat_sharing_title: "Viral sharing engine",
        feat_sharing_desc:
          "Gate games behind follows, reviews and referrals. Every share and conversion is tracked.",
        feat_analytics_title: "Real-time analytics",
        feat_analytics_desc:
          "Plays, conversions, CTA completion, redemption — every signal on a single, stunning board.",
        feat_mobile_first_title: "Mobile-first canvas",
        feat_mobile_first_desc:
          "Every game runs flawlessly on iPhone in-app browsers, with a smart blocker that nudges Facebook / Instagram users to the real browser.",
        games_eyebrow: "§ 01 — MECHANICS",
        games_title: "Eleven ways to play. One premium stack.",
        games_sub:
          "All eleven mechanics are live and production-ready — same admin, same QR, same data layer.",
        game_spin_wheel_desc: "High-stakes pointer. Visual drama.",
        game_scratch_card_desc: "Tactile reveal, silvery shimmer.",
        game_mystery_box_desc: "6-digit email code, premium 3D unboxing.",
        game_slot_machine_desc: "Three reels, arcade energy.",
        game_card_game_desc: "Flip, match, win. Memory-style.",
        game_lottery_draw_desc: "Weighted draw with viral referrals.",
        game_flappy_mascotte_desc: "Tournament leaderboard, custom mascot.",
        game_blow_candles_desc: "Blow into the mic to snuff the candles.",
        game_prediction_match_desc: "Live sports pronostics, all-correct wins.",
        game_guess_price_desc: "Closest guess to the secret price wins.",
        game_ninja_desc: "Fruit-Ninja-style slicing, live leaderboard.",
        spin_wheel: "Spin Wheel",
        scratch_card: "Scratch Card",
        advent_calendar: "Advent Calendar",
        mystery_box: "Mystery Box",
        flappy_mascotte: "Flappy Mascot",
        blow_candles: "Blow the Candles",
        lottery_draw: "Lottery",
        prediction_match: "Pronostics",
        card_game: "Memory",
        slot_machine: "Slot Machine",
        guess_price: "Guess the Price",
        ninja: "Ninja Slice",
        // Short aliases used across dashboards
        game_spin: "Spin Wheel",
        game_scratch: "Scratch Card",
        game_card: "Memory",
        game_slot: "Slot Machine",
        game_lottery: "Lottery",
        game_prediction: "Pronostics",
        game_price: "Guess the Price",
        game_ninja: "Ninja Slice",
        game_blow_candles: "Blow the Candles",
        game_flappy: "Flappy Mascot",
        game_mystery: "Mystery Box",
        game_penalty: "Penalty Shootout",
        game_registration_gift: "Registration Gift",
        registration_gift: "Registration Gift",
        game_avent: "Advent Calendar",
        game_quiz: "Quiz",
        soon: "Soon",
        live: "Live",
        ctas_eyebrow: "§ 02 — SOCIAL CTA STACK",
        ctas_title: "Eleven levers to convert attention into action.",
        ctas_sub:
          "Gate every game behind the actions that actually grow your business. Any CTA can be required or optional, with smart deep-linking on mobile.",
        cta_group_social: "Social follow",
        cta_group_reviews: "Reviews & trust",
        cta_group_growth: "Acquisition & CRM",
        cta_facebook_like: "Like your Facebook page",
        cta_instagram_follow: "Follow on Instagram",
        cta_tiktok_follow: "Follow on TikTok",
        cta_youtube_subscribe: "Subscribe on YouTube",
        cta_linkedin_follow: "Follow on LinkedIn",
        cta_google_review: "Leave a Google review",
        cta_tripadvisor_review: "Tripadvisor review",
        cta_app_download: "Download the app",
        cta_newsletter_signup: "Subscribe newsletter",
        cta_account_creation: "Create an account",
        cta_instagram_story: "Share on Instagram Story",
        ctas_footer: "Required or optional · Smart mobile deep-link · Server-side verification",
        play_demo: "Play demo",
        how_eyebrow: "§ 04 — HOW IT WORKS",
        how_title: "From zero to jackpot in three moves.",
        how_sub:
          "No SDK. No dev time. A permanent QR, a beautiful admin and a claim portal for your winners.",
        step1_title: "Configure",
        step1_desc:
          "Pick a mechanic, upload your brand, set the rewards and CTAs. GDPR opt-in baked in.",
        step2_title: "Launch",
        step2_desc:
          "Print your permanent QR once. Plug it on storefront, receipts, packaging — it never changes.",
        step3_title: "Reward",
        step3_desc:
          "Winners claim in the portal, you export qualified leads, we track every share.",
        social_eyebrow: "§ 05 — TRUSTED",
        social_title: "Retail, hospitality, beauty — they all ship faster with QRISE.",
        testimonial_1:
          "We deployed a scratch card in 15 minutes and collected 2,400 opted-in phone numbers in a weekend.",
        testimonial_1_author: "Léa · Head of Growth, Maison Clément",
        testimonial_2:
          "QRISE is the only gamification stack that feels as polished as our flagship app.",
        testimonial_2_author: "Marc · CRM Director, Aurore Retail",
        cta_eyebrow: "§ 06 — READY?",
        cta_title: "Ready to turn your marketing into a playground?",
        cta_sub:
          "Start free. No credit card. Your permanent QR is waiting.",
        cta_primary: "Create my account",
        cta_secondary: "Try the demo",
        footer_rights: "All rights reserved.",
      },
      auth: {
        title: "Welcome back",
        subtitle: "Log in to your QRISE workspace",
        email: "Email",
        password: "Password",
        login: "Log in",
        demo_admin: "Demo admin",
        demo_merchant: "Demo merchant",
        loading: "Signing in…",
        quick_fill: "Quick fill",
        tagline_title: "Premium gamification for growth-focused brands.",
        tagline_body:
          "Launch beautiful interactive campaigns, collect high-intent leads, and measure every click in real time.",
        tagline_footer: "Turning scans into loyalty.",
      },
      dashboard: {
        overview: "Overview",
        games: "Games",
        merchants: "Merchants",
        participants: "Participants",
        analytics: "Analytics",
        settings: "Settings",
        welcome: "Welcome back",
        role_admin: "Admin",
        role_merchant: "Merchant",
        kpi_plays: "Total plays",
        kpi_leads: "Leads captured",
        kpi_conversion: "Conversion",
        kpi_games: "Active games",
        kpi_merchants: "Merchants",
        timeseries: "Plays over last 14 days",
        cta_performance: "CTA performance",
        per_game: "Per-game performance",
        no_data: "No data yet",
        loading: "Loading…",
        back: "Back",
        new_game: "New game",
        new_merchant: "New merchant",
        copy_link: "Copy link",
        copied: "Copied",
        share_link_hint: "For WhatsApp & social networks (rich preview with image)",
        copy_share_link: "Copy social link",
        qr: "QR",
        export_csv: "Export CSV",
        export_xlsx: "Export Excel",
        export_json: "Export JSON",
        export_failed: "Export failed",
        search: "Search…",
        all_games: "All games",
        th_game: "Game",
        th_plays: "Plays",
        th_wins: "Wins",
        th_conversion: "Conversion",
        th_name: "Name",
        th_company: "Company",
        th_email: "Email",
        th_games: "Games",
        th_date: "Date",
        th_phone: "Phone",
        th_receipt: "Receipt",
        th_result: "Result",
        th_win: "Win",
        th_optin: "Opt-in",
        opt_in_yes: "Opted in to marketing communications",
        opt_in_no: "Not opted in",
        th_redeemed: "Redeemed",
        th_predictions: "Predictions",
        th_score: "Score",
        score_unit: "pts",
        view_predictions: "View predictions",
        predictions_modal_title: "Participant's predictions",
        predictions_modal_loading: "Loading…",
        predictions_modal_empty: "No predictions recorded for this participant.",
        predictions_match: "Match",
        predictions_pick: "Pick",
        predictions_real: "Actual",
        predictions_correct: "Correct",
        predictions_wrong: "Wrong",
        predictions_pending: "Pending",
        mark_redeemed: "Mark as collected",
        confirm_mark_redeemed: "Mark this prize as collected by the customer?",
        th_shipping: "Shipping",
        th_address: "Address",
        shipping_to_ship: "To ship",
        shipping_shipped: "Shipped",
        shipping_delivered: "Delivered",
        mark_shipped: "Mark as shipped",
        mark_delivered: "Mark as delivered",
        confirm_mark_shipped: "Mark this gift as shipped to the customer?",
        confirm_mark_delivered: "Mark this gift as delivered to the customer?",
        marked_shipped: "Marked as shipped",
        marked_delivered: "Marked as delivered",
        th_antirejeu: "Anti-replay",
        receipt_dialog_title: "Proof of purchase",
        receipt_confidence: "Confidence {{value}}%",
        receipt_open_full: "Open the original image →",
        reset_fp: "Reset",
        reset_fp_hint:
          "Allow this participant (same IP + device) to play this contest again. Useful for fixing false positives.",
        confirm_reset_fp:
          "Reset anti-replay for this participant? They will be able to play this contest one more time.",
        fp_reset_done: "Anti-replay reset",
        fp_reset_done_badge: "Reset",
        select_all_participants: "Select all",
        select_participant: "Select this participant",
        delete_selected: "Delete ({{count}})",
        delete_participant: "Delete this participant",
        confirm_delete_participants:
          "Permanently delete {{count}} participant(s)? This cannot be undone — their entries, prizes and draw tickets will be lost.",
        participants_deleted: "{{count}} participant(s) deleted",
        marked_redeemed: "Marked as collected",
        badge_redeemed: "Collected",
        badge_active: "Active",
        badge_off: "Off",
        badge_win: "Win",
        badge_lose: "Lose",
        badge_required: "Required",
        badge_optional: "Optional",
        plays_count: "{{count}} plays",
        unassigned: "Unassigned",
        confirm_delete_game: "Delete this game?",
        confirm_delete_merchant: "Delete this merchant?",
        confirm_duplicate_game:
          "Duplicate this game? The copy will be created deactivated.",
        game_created: "Game created",
        game_deleted: "Game deleted",
        game_duplicated: "Game duplicated — editing the new copy",
        duplicate: "Duplicate",
        duplicate_hint: "Creates a deactivated copy of this game",
        duplicate_dialog_title: "Duplicate this game",
        duplicate_dialog_body:
          "The copy will be created deactivated, ready for adjustments. Prizes and CTAs are kept; participants and winners are not copied.",
        duplicate_assign_to: "Assign to merchant",
        duplicate_select_merchant: "Choose a merchant",
        duplicate_same_merchant: "Same merchant",
        duplicate_merchant_switch_warning: "The copy will be assigned to",
        duplicate_merchant_switch_note:
          "Remember to adjust the rules, CTAs and coupon codes if needed.",
        duplicate_confirm_btn: "Duplicate",
        merchant_created: "Merchant created",
        merchant_deleted: "Merchant deleted",
        merchant_slug_saved: "URL updated",
        th_permanent_qr: "Permanent QR",
        permanent_qr_for: "Permanent QR code for",
        permanent_qr_badge: "Your permanent QR code",
        permanent_qr_title: "One QR. Every game. Forever.",
        permanent_qr_body:
          "This is the QR code to print in your {{brand}} store. It stays the same across campaigns — whenever you launch a new game, this QR automatically redirects customers to the active one.",
        download_qr: "Download QR",
        preview_url: "Preview",
        copy_error: "Could not copy",
        your_brand: "your brand",
        active_game_label: "Active game: {{title}}",
        no_active_game: "No active game right now",
        game_activated: "Game activated",
        game_deactivated: "Game deactivated",
        toggle_activate_tooltip: "Click to activate this game",
        toggle_deactivate_tooltip: "Click to deactivate this game",
        th_status: "Status",
        th_leads: "Leads",
        th_last_play: "Last activity",
        th_total: "Total",
        search_participants: "Search by name, email, phone, prize…",
        no_search_match: "No participant matches your search.",
        th_dates: "Dates",
        no_dates: "No dates set",
        dates_tooltip: "Start date → End date (GMT+4)",
        filter_by_merchant: "Filter by merchant",
        all_merchants: "All merchants",
        unassigned_merchant: "Unassigned",
        filter_by_status: "Filter by status",
        all_statuses: "All statuses",
        status_active: "Active",
        status_inactive: "Inactive",
        view_participants: "Participants",
        top_merchants_title: "Top merchants · 7 days",
        top_merchants_subtitle: "Most active brands this week",
        top_merchants_empty: "No participations in the last 7 days",
        rank: "Rank",
        plays_7d: "{{count}} plays",
        leads_7d: "{{count}} leads",
        conversion_short: "Conv.",
      },
      probability_calc: {
        title: "Probability calculator",
        subtitle: "Avoid the cumulative probability trap",
        current_cumul: "currently cumulative",
        detection: "Auto-detection",
        premium_lots: "premium lot(s)",
        premium_def: "winning + limited stock + available",
        consolation_lots: "consolation lot(s)",
        consolation_def: "everything else absorbs the rest",
        depleted_lots: "depleted lot(s)",
        depleted_def: "kept at 0% (already won)",
        no_premium:
          "No premium lot detected. Enable 'Winning' and set 'Initial quantity' on the lots to distribute.",
        plays_expected: "Expected plays",
        plays_hint: "Total estimated participations over the whole campaign.",
        lots_to_distribute: "Lots to distribute",
        lots_hint: "How many premium lots you'd ideally distribute.",
        recommendation: "Recommendation",
        per_premium: "Weight per premium lot",
        per_consolation: "Weight per consolation",
        lots: "lots",
        cumulative: "cumulative",
        expected: "Expected",
        p_none: "P(no lot falls)",
        p_all: "P(distribute all)",
        over_allocated:
          "Too many lots for this play count. Increase expected plays or reduce lots.",
        apply_btn: "Apply weights",
        apply_hint:
          "Premium lot weights are unified and the rest is split across consolation segments. Total guaranteed at 100%.",
      },
      game_editor: {
        title: "Title",
        description: "Description",
        export_pdf: "PDF sheet",
        export_pdf_hint: "Download the game's technical PDF sheet",
        game_type: "Game type",
        language: "Game language",
        language_en: "English",
        language_fr: "Français",
        segments: "Wheel segments",
        prize_pool: "Prize pool",
        ctas: "Calls to action",
        add_segment: "Add segment",
        add_cta: "Add CTA",
        label: "Label",
        color: "Color",
        winning: "Winning",
        weight: "Weight",
        chance: "% chance",
        actual_chance: "actual",
        total_chance: "Total",
        normalize_sum: "Normalize to 100%",
        sum_ok: "Probabilities sum to 100%",
        sum_warning: "Sum is {{sum}}% — values will be rescaled on spin.",
        initial_qty: "Initial quantity",
        remaining_qty: "Remaining",
        unlimited: "Unlimited",
        out_of_stock: "Out of stock",
        claim_days: "Days to claim",
        claim_deadline: "Claim deadline",
        coupon: "Coupon code",
        redemption_url: "Website address",
        prize_details: "Prize details",
        segment_image: "Prize image",
        segment_image_hint:
          "Optional — shown inside the game (reels, wheel, cards, box). Cut-out PNG (transparent background) recommended.",
        segment_image_add: "Add image",
        segment_image_replace: "Replace",
        type: "Type",
        url: "URL",
        url_hint: "The web URL. On mobile, a native app deeplink will be used automatically when available (Instagram, Facebook, TikTok, YouTube, LinkedIn, Tripadvisor).",
        ios_url: "iOS App Store URL",
        android_url: "Google Play URL",
        cta_instruction: "Helper text shown under the action (optional)",
        cta_instruction_hint: "Leave empty to keep the default text for this action type.",
        confirm_hint: "Confirmation screen after entering the draw (lottery / quiz perfect score). Leave empty to keep the default texts.",
        confirm_title: "Confirmation title",
        confirm_body: "Confirmation text",
        quiz_intro_hint: "Quiz welcome card (before the first question). Leave empty to keep the default texts.",
        quiz_intro_text: "Welcome text",
        quiz_winners_label: "Winners badge (e.g. “1 winner drawn on 14 November”)",
        test_link_title: "Advertiser test link",
        test_link_hint: "Works before the start date, after the end and while paused; replays are unlimited. Test plays are stored apart: they never appear in participants, stats or draws, prize stocks are untouched and emails are prefixed [TEST]. Never share it publicly.",
        test_link_copy: "Copy",
        test_link_open: "Test",
        test_link_copy_error: "Could not copy the link",
        app_urls_hint: "iOS visitors are sent to the App Store, Android to Google Play. The fallback URL above is used on desktop or when a store URL is missing.",
        required: "Required",
        win_message: "Win message",
        lose_message: "Lose message",
        theme_color: "Theme color",
        rules_url: "Rules link",
        rules_url_hint: "Optional URL to your game's terms and conditions",
        save: "Save changes",
        saved: "Saved",
        duplicate: "Duplicate",
        duplicate_hint: "Creates a deactivated copy of this game",
        duplicate_confirm:
          "Duplicate this game? The new game will be created deactivated, ready for adjustments.",
        duplicated: "Game duplicated — editing the new copy",
        assign: "Assigned to",
        none: "— unassigned —",
        active: "Active",
        public_link: "Public game link",
        merchant_qr_link: "Merchant QR code link (permanent)",
        merchant_qr_hint:
          "Printed once, valid forever. The QR redirects to whichever game is currently active for this merchant.",
        sibling_warning_title: "Another active game on this merchant",
        sibling_warning_body:
          "The merchant's permanent QR code will point to whichever active game was created most recently. Deactivate the other games if you want this one to take over.",
        start_date: "Start date",
        end_date: "End date",
        start_time: "Opening time",
        end_time: "Closing time",
        computed_status: "Current status",
        date_hint:
          "Times are in GMT+4. Without a closing time, the game ends at 00:00 GMT+4 on the end date (exclusive). Leave blank for no date constraint.",
        winners_count: "Number of winners",
        winners_count_hint:
          "How many participants will be drawn as winners when you trigger the lottery.",
        pred_sport: "Sport",
        pred_sport_hint: "Defines available teams and scoring format",
        pred_teams_title: "Teams library",
        pred_teams_hint: "Teams are shared across all prediction games of this sport",
        pred_team_add: "Add team",
        pred_team_name: "Team name",
        pred_team_logo: "Logo",
        pred_team_logo_upload: "Upload logo",
        pred_team_delete: "Delete",
        pred_matches_title: "Matches",
        pred_match_add: "Add match",
        pred_match_team_a: "Team A (home)",
        pred_match_team_b: "Team B (away)",
        pred_match_datetime: "Kick-off date & time (GMT+4)",
        pred_end_before_match: "End date must be before the first match kick-off",
        pred_match_result: "Final result",
        pred_match_score_a: "Score A",
        pred_match_score_b: "Score B",
        pred_match_winner: "Winner",
        pred_match_winner_a: "Team A wins",
        pred_match_winner_b: "Team B wins",
        pred_save_matches: "Save matches",
        pred_matches_saved: "Matches saved",
        pred_result_saved: "Result saved",
        pred_draw_btn: "Draw winners",
        pred_missing_results: "Please enter all final results first",
        pred_reward_mode: "Reward mode",
        pred_reward_mode_hint:
          "Draw = random winners among all-correct predictions. 100% winners = everyone with all-correct predictions wins the guaranteed prize.",
        pred_reward_draw: "Random draw",
        pred_reward_all: "100% winners",
        pred_prize_label: "Guaranteed prize *",
        pred_prize_label_ph: "E.g. A free dessert",
        pred_coupon_code: "Coupon code (optional)",
        pred_coupon_code_hint:
          "Leave empty to auto-generate a unique code per winner.",
        pred_claim_days: "Validity (days)",
        pred_claim_days_hint:
          "How long winners can claim their prize after distribution.",
        pred_claim_deadline: "Latest claim date (optional)",
        pred_claim_deadline_hint:
          "If set, overrides the validity in days. Shown in the winner's email (“Expires on”).",
        pred_prize_instructions: "Prize instructions (email)",
        pred_prize_instructions_ph: "E.g. Show this email at the counter.",
        pred_prize_required: "Enter the guaranteed prize name first",
        pred_distribute_btn: "Distribute prizes",
        gp_real_price: "Real price (€)",
        gp_real_price_hint: "Secret — never shown to players",
        gp_image: "Product / window image",
        gp_image_hint: "Display a single product or a shop window with multiple items",
        gp_draw_btn: "Draw winners",
        quiz_title: "Quiz questions",
        quiz_hint:
          "Players only see the questions. Everyone who answers ALL questions right is automatically entered into the draw. Wrong answers → score shown + one last attempt with the same details.",
        quiz_winners_hint: "Winners drawn at random among players with a perfect score.",
        quiz_time: "Time per question",
        quiz_time_none: "No time limit",
        quiz_time_seconds: "{{seconds}} seconds",
        quiz_time_hint: "When time runs out, the quiz moves on to the next question automatically.",
        quiz_question_n: "Question {{n}}",
        quiz_question_ph: "Type your question…",
        quiz_multiple: "Several correct answers",
        quiz_multiple_hint: "Player ticks boxes (several) instead of a single choice.",
        quiz_show_expected: "Show the number of expected answers",
        quiz_show_expected_hint: "E.g. “2 answers expected” on questions with several correct answers.",
        quiz_unlimited: "Unlimited participation",
        quiz_unlimited_hint: "Players can replay and retry as often as they like. One chance each in the draw (1 per email).",
        quiz_answers_label: "Answers — tick the correct one(s)",
        quiz_mark_correct: "Mark as correct",
        quiz_answer_ph: "Answer {{n}}",
        quiz_add_answer: "Add an answer",
        quiz_link_toggle: "Help link (e.g. catalogue, product page)",
        quiz_link_label_ph: "Link text, e.g. “See the catalogue”",
        quiz_question_invalid: "Needs a question text, at least 2 answers and at least 1 correct answer.",
        quiz_no_questions: "No questions yet — add your first question below.",
        quiz_add_question: "Add a question",
        quiz_retry_message: "Message after a failed 1st attempt",
        quiz_retry_message_hint: "Shown with the wrong questions and the “Try again” button. The “Losing message” (Texts section) is used for the pop-up after the 2nd failure.",
        usable_from: "Coupon usable from",
        usable_from_hint:
          "The coupon code sent by email will only be redeemable starting from this moment.",
        usable_immediately: "Immediately",
        usable_tomorrow: "Tomorrow",
        usable_next_monday: "Next Monday",
        usable_custom: "Custom date…",
        promo_mode_badge: "Online promo mode",
        promo_description: "Email description (optional)",
        promo_description_placeholder:
          "The 10% discount is usable on our website or our physical stands…",
        promo_description_hint:
          "This text will be displayed in the email below the coupon. Use it to explain where/how to redeem the code.",
        ninja_duration: "Duration",
        ninja_winners_hint: "Top N scorers win (1st, 2nd, 3rd…)",
        ninja_points: "Points / product",
        ninja_points_hint: "Base points per sliced product (x3 max combo)",
        ninja_blade_color: "Blade color",
        ninja_product_images: "Product images",
        ninja_product_images_hint:
          "Upload photos of your products — they'll be the projectiles. If empty, default fruit emojis are used.",
        ninja_upload_product: "Add a product image",
        ninja_load_demo: "Load demo products",
        ninja_bomb_image: "Bomb image",
        ninja_bomb_image_hint:
          "Hitting this ends the run instantly. Defaults to a bomb emoji.",
        ninja_upload_bomb: "Upload bomb image",
        ninja_total_participants: "Total plays",
        ninja_best_score: "Best score",
        ninja_winners_drawn: "Winners drawn",
        ninja_draw_btn: "Draw winners",
        card_back_color: "Card back color",
        card_back_color_hint:
          "Color used behind the cards (card_game). The merchant logo appears as a subtle watermark on top.",
        scratch_color: "Scratch foil color",
        scratch_color_hint:
          "Color of the scratch foil. The merchant logo appears as a subtle watermark on top.",
        wheel_label_orientation: "Wheel text orientation",
        wheel_design: "Wheel design",
        wheel_design_hint: "Choose the look of the wheel for this game. You can switch back at any time.",
        wheel_design_classic: "Current design",
        wheel_design_premium: "New design",
        wheel_rim_color: "Rim colour",
        wheel_curved_text: "Curved text under the wheel",
        wheel_curved_text_default: "And lots of other gifts",
        wheel_button_label: "Button text",
        wheel_themes: "Themes — one click applies wheel and button colours (you can fine-tune afterwards)",
        wheel_theme_applied: "Theme “{{name}}” applied — remember to save",
        wheel_theme_fastfood: "Fast-food",
        wheel_theme_noel: "Christmas",
        wheel_theme_valentin: "Valentine's Day",
        wheel_theme_halloween: "Halloween",
        wheel_theme_luxe: "Luxury",
        wheel_show_prize_names: "Show prize names",
        wheel_show_prize_names_hint: "Off: winning segments show the prize photo, or a gift icon by default. Losing segments keep their text (e.g. “Lost”, editable in the prize list).",
        wheel_premium_segments_hint: "Segment colours and texts are set in the prize list. Winning segments show a gift icon (or the prize photo) above their text.",
        wheel_label_orientation_hint:
          "Switch to vertical when your prize labels are too long to fit horizontally inside a wheel slice. Vertical text runs along the radial direction (from center to rim) and accepts up to 22 characters.",
        wheel_label_horizontal: "Horizontal (default)",
        wheel_label_vertical: "Vertical (radial)",
        wheel_label_preview_caption:
          "Live preview reflects your real prize labels. Long horizontal labels wrap to 2 lines automatically.",
        text_colors: "Title & description colors",
        text_colors_hint:
          "Override the default text color on the public game page. Useful when your background image makes the title or description hard to read. Leave empty to use the theme default (auto-adapts to light/dark mode).",
        title_color: "Title color",
        description_color: "Description color",
        color_reset: "Reset to default",
        color_using_default: "Using theme default",
        fonts_section: "Typography",
        fonts_hint:
          "Pick a custom font for each element of the public game page. Leave on default to keep the theme font.",
        font_title: "Title",
        font_description: "Description",
        font_prizes: "Prize labels",
        font_messages: "Win / lose messages",
        font_buttons: "Buttons",
        font_cta: "Actions (CTA)",
        font_default: "Default (theme)",
        advent_title: "Advent Calendar — Configuration",
        advent_mode: "Game mode",
        advent_mode_daily: "Daily — one door per day",
        advent_mode_free: "Free — a single door of choice",
        advent_days: "Number of doors",
        advent_start: "Date of door #1",
        advent_catchup: "Missed doors catch-up",
        advent_catchup_hint: "If enabled, players can open past doors. Otherwise a missed door is lost.",
        advent_doors: "Doors — prize, win probability and stock",
        advent_col_day: "Door",
        advent_col_prize: "Prize (empty = losing door)",
        advent_col_prob: "Win %",
        advent_col_stock: "Stock",
        advent_prize_ph: "E.g. Free coffee",
        advent_reminder: "Daily email reminder",
        advent_reminder_hint: "Every morning (8am Réunion time), participants who haven't opened today's door receive \"Your door of the day awaits 🎁\".",
        advent_doors_hint: "Each door has its prize and probability. A door without a prize always loses. Stock caps the number of wins (empty = unlimited).",
        advent_ambience_title: "Ambience & decor",
        advent_theme_snow: "Snow / Christmas",
        advent_theme_stars: "Starry night",
        advent_theme_autumn: "Autumn",
        advent_theme_spring: "Spring / Easter",
        advent_theme_summer: "Summer / Tropical",
        advent_theme_valentine: "Valentine's",
        advent_theme_ramadan: "Ramadan / Golden night",
        advent_theme_birthday: "Birthday / Brand",
        advent_theme_none: "No effect",
        advent_intensity: "Particle intensity",
        advent_intensity_light: "Light",
        advent_intensity_normal: "Normal",
        advent_intensity_festive: "Festive",
        advent_bg_color: "Background colour",
        advent_bg_preview: "Background",
        advent_bg_hint: "Without a custom colour the theme decor is used (the Birthday theme reuses the game's main colour). A light colour is automatically darkened to keep text readable.",
        advent_sound: "Sound ambience",
        advent_sound_music_sfx: "Music + door sound",
        advent_sound_sfx: "Door sound only",
        advent_sound_off: "Silent",
        advent_music_play: "Play music",
        advent_music_stop: "Stop",
        advent_sfx_play: "Door-open sound",
        advent_sound_hint: "Music and sounds are generated by the browser (no file to load). Players can mute at any time with the speaker shown on the calendar.",
        font_weight_auto: "Auto weight",
        font_using_default: "Using theme font",
        appearance_section: "Buttons & effects",
        appearance_hint:
          "Customize the buttons, background darkening, display mode and win effects of the public game page.",
        button_bg: "Button background",
        button_text: "Button text",
        button_radius: "Button shape",
        radius_default: "Default (rounded)",
        radius_pill: "Pill",
        radius_square: "Square",
        continue_label: "\u201CContinue\u201D button text",
        ready_label: "\u201CReady to play\u201D button text",
        overlay_label: "Background darkening",
        overlay_hint:
          "Dark veil over the background image for readability. Default 55%.",
        theme_label: "Display mode",
        theme_auto: "Auto (player's choice)",
        theme_light: "Force light",
        theme_dark: "Force dark",
        confetti_label: "Win confetti colors",
        confetti_enable: "Customize confetti",
        hub_logo_label: "Merchant logo at the wheel center",
        hub_logo_hint: "Replaces the SPIN text with the merchant logo.",
        size_sm: "Small",
        size_md: "Normal",
        size_lg: "Large",
        size_xl: "Extra large",
        win_image_label: "Win image / GIF",
        og_image_label: "Share image (social)",
        sounds_label: "Game sounds",
        sounds_hint:
          "Wheel tick + victory jingle. The player can mute the sound.",
        form_section: "Player form",
        phone_field: "Phone field",
        phone_required: "Required",
        phone_optional: "Optional",
        phone_hidden: "Hidden",
        birthdate_label: "Ask for birth date",
        children_field: "Number of children field",
        city_field: "City field",
        button_bg_2: "Gradient — 2nd colour",
        quiz_select_color: "Selected answer (quiz)",
        quiz_select_color_preview: "✓ Chosen answer",
        advent_door_image: "Door image (optional)",
        advent_door_image_hint: "The optional (ideally square) image is revealed on the back of the door when it opens.",
        button_bg_2_hint: "Gradient preview",
        purchase_proof_title: "Till receipt required",
        daily_prize_title: "Winners per day",
        daily_prize_hint: "Limited number of winners per day, all players combined: once reached, the next players lose until midnight (Reunion time). Unwon prizes are not carried over. Each participant can play once a day.",
        daily_win_limit: "Winners per day",
        purchase_proof_hint:
          "If enabled, the participant must upload or take a photo of their till receipt before playing. AI OCR automatically extracts the total amount, date and merchant name for review.",
        purchase_filters: "Automatic validation (optional)",
        purchase_min_amount: "Minimum total amount",
        purchase_min_amount_placeholder: "e.g. 15 €",
        purchase_max_days: "Ticket age limit (days)",
        purchase_max_days_placeholder: "e.g. 7 days",
        purchase_merchant_keyword: "Merchant name must contain",
        purchase_merchant_keyword_placeholder: "e.g. DEALRUN",
        purchase_filters_hint:
          "Leave empty to disable a filter. A non-compliant ticket is rejected with a clear message; the merchant always sees the photo in the participants list.",
        shipping_address_title: "Collect shipping address",
        shipping_address_hint:
          "If enabled, the participant must provide a postal address (street, postal code, city, optional 2nd line) before finalising. Use this for campaigns where you ship a physical reward (stickers, mugs, t-shirts).",
      },
      errors: {
        generic: "Something went wrong. Please try again in a moment.",
        invalid_input: "Some details are invalid. Please check the form.",
        already_participated: "You have already taken part in this contest. Only one entry per person and per phone is allowed.",
        already_played_today: "You already played today. Come back tomorrow to try your luck again!",
        daily_prize_needs_losing: "Add at least one losing segment (e.g. “Try again”) to use “One prize per day”.",
        device_identity_mismatch: "To prevent fraud, you can't play with different details on this phone. Use the same details as your first entry, or use another phone.",
        receipt_required: "Proof of purchase is required to take part in this game.",
        receipt_amount_too_low: "The receipt doesn't meet the minimum amount required (€{{min_amount}}).",
        receipt_too_old: "The receipt must be less than {{max_days}} days old.",
        receipt_merchant_mismatch: "This receipt doesn't seem to come from “{{expected_keyword}}”.",
        receipt_already_used: "This receipt has already been used to take part in a game.",
        shipping_address_required: "A postal address (street, postcode, city) is required to complete your registration.",
        advent_not_configured: "The calendar doesn't have a start date yet.",
        advent_not_started: "The calendar hasn't started yet. Come back soon!",
        door_locked: "This door isn't unlocked yet. Come back on the day!",
        door_missed: "This door's day has passed — catching up isn't allowed on this calendar.",
        door_already_opened: "You've already opened this door. Come back tomorrow for the next one!",
        no_attempts_left: "You've already used both of your attempts.",
        invalid_code_format: "The code must contain 6 digits.",
        code_not_found: "This code doesn't match any entry. Check the spelling or copy it again from your email.",
        game_not_open: "This game isn't open right now.",
        game_not_found: "This game can't be found or is no longer available.",
        ctas_missing: "Please complete all the required steps before playing.",
        phone_required: "A phone number is required.",
        city_required: "City is required.",
        children_required: "The number of children is required.",
        name_required: "Your name is required.",
        predictions_closed: "Predictions are closed: a match has already started.",
        pred_missing: "Please predict every match.",
        quiz_incomplete: "Please answer every question.",
        session_not_found: "Your game session can't be found. Reload the page and try again.",
        score_rejected: "Score rejected. Please play a regular game again.",
        claim_not_found: "This coupon link is invalid or has expired.",
        score_not_counted: "Score not counted",
      },
      flappy: {
        timeout: "Network timeout",
        hud_score: "Score",
        intro_eyebrow: "Mini-game",
        intro_title: "Make the mascot fly!",
        intro_sub: "Tap the screen to flap and fly between the obstacles. The higher your score, the better!",
        intro_btn: "Play now",
        submitting: "Calculating your score…",
        result_eyebrow: "Final score",
        rank: "You're #{{rank}} out of {{total}}",
        rank_in_top: "You're currently in the top {{n}}! We'll email you if you're still a winner when the contest ends.",
        rank_out_top: "The top {{n}} scores win. Keep playing… oh wait, one entry per person 😄 Fingers crossed!",
        tournament_ends: "Contest ends: {{date}}",
        result_win: "You won!",
        result_reveal: "See my gift",
        result_lose: "No prize this time",
        result_lose_sub: "You needed to reach the minimum score. Come back next time!",
      },
      mystery: {
        already: "You have already taken part in this game",
        back_to_email: "Back",
        claim_btn: "See my gift",
        code_format: "The code must contain 6 digits.",
        code_invalid: "Invalid code",
        editor_email_intro: "Email intro text (optional)",
        editor_email_intro_hint: "If left empty, a default text is used. 500 characters max.",
        editor_email_intro_placeholder: "You took part in the Valentine's special draw at Bistro Lumière. Here's your code to open your mystery box…",
        editor_email_subject: "Code email subject (optional)",
        editor_email_subject_placeholder: "🎁 Your code to open the box at Bistro Lumière",
        editor_style: "Box style",
        editor_style_hint: "The chosen style is shown to players on the public page and in the opening animation.",
        editor_title: "Mystery box settings",
        enter_manually: "Enter the code manually",
        eyebrow: "Mystery box",
        fallback_text: "We couldn't send the email to {{email}}, but here's your code anyway. Write it down — you'll need it to open the box again.",
        fallback_title: "Here's your code",
        intro_text: "Take part now to receive your 6-digit code by email. With this code, you can try to open the box and find out whether it holds a gift for you.",
        intro_title: "What's inside the box?",
        lose_eyebrow: "Empty box",
        lose_text: "The code doesn't match any prize in this box. Try your luck in a future game!",
        participate: "Get my code by email",
        replay: "You've already opened this box",
        sending: "Sending your code…",
        sent_spam_hint: "Remember to check your spam folder if you don't see it.",
        sent_text: "We've sent an email with your 6-digit code to {{email}}. Click the button in the email to open your box.",
        sent_title: "Check your inbox!",
        submit_error: "Couldn't send the code by email",
        unlock_btn: "Open my box",
        unlocking: "Opening the box…",
        win_eyebrow: "You won",
        your_code: "Your 6-digit code",
        your_address: "your address",
      },
      claim: {
        badge: "QRISE · Your prize",
        bravo_name: "Well done {{name}}",
        bravo: "Well done",
        title: "You won!",
        at: "at",
        default_prize: "Your prize",
        code_label: "Code to show at the counter",
        show_screen: "Show this screen at the front desk to collect your prize.",
        redeemed_pill: "Prize validated · recorded with the merchant",
        game_by: "Game by QRISE",
        already_eyebrow: "Already collected",
        already_title: "Prize already collected",
        already_body_1: "You have already collected your prize for this contest.",
        already_body_2: "Thanks for taking part!",
        collected_on: "Collected on {{date}}",
        soon_title: "Available soon",
        soon_body_1: "Your prize can be collected <strong>{{when}}</strong>.",
        soon_body_2: "Come back then and click the link from your email again.",
        when_next_monday: "next Monday",
        when_tomorrow: "tomorrow",
        when_date: "on {{date}}",
        when_soon: "soon",
        expired_title: "Code expired",
        expired_body: "Sorry, the collection period for this prize is over.",
        expired_contact: "Contact <strong>{{merchant}}</strong> if you think this is a mistake.",
        invalid_title: "Invalid link",
        receipt: "Receipt",
      },
      play: {
        page_badge: "QRISE Game",
        grand_draw_kicker: "Grand final draw",
        grand_draw_banner_all_one:
          "By playing, you're automatically entered into the grand final draw — 1 winner at the end of the campaign!",
        grand_draw_banner_all_other:
          "By playing, you're automatically entered into the grand final draw — {{count}} winners at the end of the campaign!",
        grand_draw_banner_losers_one:
          "Second chance: every non-winning player is automatically entered into the grand final draw — 1 winner!",
        grand_draw_banner_losers_other:
          "Second chance: every non-winning player is automatically entered into the grand final draw — {{count}} winners!",
        grand_draw_result_win_one:
          "Bonus: you're also automatically entered into the grand final draw — 1 winner drawn at the end of the campaign. Keep an eye on your inbox!",
        grand_draw_result_win_other:
          "Bonus: you're also automatically entered into the grand final draw — {{count}} winners drawn at the end of the campaign. Keep an eye on your inbox!",
        grand_draw_result_lose_one:
          "Good news: you're automatically entered into the grand final draw — 1 winner drawn at the end of the campaign. Keep an eye on your inbox!",
        grand_draw_result_lose_other:
          "Good news: you're automatically entered into the grand final draw — {{count}} winners drawn at the end of the campaign. Keep an eye on your inbox!",
        your_info: "Enter your info to play",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        phone: "Phone",
        optional_suffix: "optional",
        birthdate: "Birth date",
        children_count: "Number of children",
        city: "City",
        address_line2: "Address complement (optional)",
        postal_code: "Postal code",
        city: "City",
        shipping_section_title: "Postal address",
        shipping_section_hint: "",
        registration_gift_finish: "Finalise my registration",
        registration_gift_done_kicker: "Registration confirmed",
        registration_gift_done_title: "Thank you, your gift is on its way!",
        registration_gift_done_body:
          "We've recorded your details and will ship your reward to the address below soon.",
        registration_gift_address_recap: "Your shipping address",
        registration_gift_email_notice:
          "A confirmation email with the recap of your address has been sent to your inbox.",
        continue: "Continue",
        gdpr_consent:
          "I agree to receive marketing communications from {{merchant}} and authorise sharing my contact details (email, phone) for this purpose.",
        gdpr_hint:
          "Optional — your data is protected. You can participate without checking this box; in that case, only your first/last name will be visible to the merchant. An anonymous technical signature (IP + device) is kept for the duration of the game to prevent duplicate entries.",
        already_eyebrow: "Already participated",
        already_title: "You already played this contest",
        already_title_today: "You already played today",
        already_hint_today: "One go per person per day. Come back tomorrow for a new chance to win!",
        already_hint:
          "Only one entry per person and per phone number is allowed per contest. A new game by the same merchant will be available shortly — come back soon!",
        already_game: "Game concerned",
        complete_actions: "Complete these quick actions",
        cta_banner_eyebrow: "To play",
        cta_banner_single: "To try your luck, {{action}}.",
        cta_banner_double: "To try your luck, {{action1}} and {{action2}}.",
        cta_banner_multi: "To try your luck, complete the {{count}} quick actions below.",
        cta_banner_hint:
          "Tap <b>Open</b> to validate each step, then come back here and press <b>Ready to play?</b>",
        cta_banner_eyebrow_registration: "To sign up",
        cta_banner_single_registration: "To receive your gift, {{action}}.",
        cta_banner_double_registration: "To receive your gift, {{action1}} and {{action2}}.",
        cta_banner_multi_registration: "To receive your gift, complete the {{count}} quick actions below.",
        cta_banner_hint_registration:
          "Tap <b>Open</b> to validate each step, then come back here and press <b>Finalise my registration</b>.",
        cta_banner_action_facebook_like: "like our <b>Facebook</b> page",
        cta_banner_action_instagram_follow: "follow <b>{{merchant}}</b> on <b>Instagram</b>",
        cta_banner_action_tiktok_follow: "follow <b>{{merchant}}</b> on <b>TikTok</b>",
        cta_banner_action_youtube_subscribe: "subscribe to our <b>YouTube</b> channel",
        cta_banner_action_linkedin_follow: "follow <b>{{merchant}}</b> on <b>LinkedIn</b>",
        cta_banner_action_google_review: "leave a review and a comment on <b>Google</b>",
        cta_banner_action_tripadvisor_review: "leave a review on <b>Tripadvisor</b>",
        cta_banner_action_app_download: "download our <b>app</b>",
        cta_banner_action_newsletter_signup: "subscribe to our <b>newsletter</b>",
        cta_banner_action_account_creation: "create an <b>account</b> on our website",
        cta_banner_action_instagram_story: "share a <b>story on Instagram</b>",
        cta_inst_facebook_like: "Like our Facebook page",
        cta_inst_instagram_follow: "Like our Instagram page",
        cta_inst_tiktok_follow: "Follow us on TikTok",
        cta_inst_youtube_subscribe: "Subscribe to our YouTube channel",
        cta_inst_linkedin_follow: "Follow our LinkedIn page",
        cta_inst_google_review: "Leave a review and a comment on Google",
        cta_inst_tripadvisor_review: "Leave a review on Tripadvisor",
        cta_inst_app_download: "Download our app",
        cta_inst_newsletter_signup: "Sign up for our newsletter",
        cta_inst_account_creation: "Create an account on our website",
        cta_inst_instagram_story: "Share a story on Instagram",
        receipt_eyebrow: "Final step",
        receipt_title: "Your till receipt",
        receipt_intro:
          "To validate your entry, upload or take a photo of your till receipt.",
        receipt_take_photo: "Take a photo",
        receipt_pick_from_gallery: "Import from gallery",
        receipt_replace: "Replace photo",
        receipt_uploading: "Uploading…",
        receipt_analyzing: "Reading your receipt…",
        receipt_ready_title: "Receipt received",
        receipt_ready_desc:
          "Your receipt has been uploaded. You can now play.",
        receipt_ocr_amount: "Amount",
        receipt_ocr_date: "Date",
        receipt_ocr_merchant: "Merchant",
        receipt_privacy:
          "Your receipt is stored only to validate your entry — visible only to {{merchant}}.",
        receipt_error_network:
          "Could not upload your receipt. Please check your connection and try again.",
        receipt_error_type:
          "Unsupported file type. Please upload a JPG, PNG or HEIC photo.",
        receipt_error_size: "File too large (8 MB max).",
        receipt_continue: "Validate and play",
        receipt_back: "Back",
        receipt_required_badge: "Required by the contest rules",
        receipt_amount_too_low:
          "This receipt does not meet the required minimum amount ({{min}} €).",
        receipt_too_old: "Your receipt must be less than {{days}} days old.",
        receipt_merchant_mismatch:
          "This receipt does not appear to come from “{{keyword}}”.",
        receipt_required: "A proof of purchase is required to play.",
        rappel_eyebrow: "Quick reminder",
        rappel_title: "Before you play",
        rappel_continue: "I'm ready, let's go!",
        legal_notice: "Legal notice",
        copy_error: "Copy failed — please write the code down.",
        popup_info_title: "More details",
        address_line1: "Address",
        legal_privacy: "Privacy",
        legal_run_contest: "Run my contest",
        pred_matches_count_one: "{{count}} match",
        pred_matches_count_other: "{{count}} matches",
        rappel_dont_show_again: "Don't show this again on this device",
        rappel_step1_fallback: "I complete the required action",
        rappel_step1_facebook_like: "I <b>like</b> the Facebook page",
        rappel_step1_instagram_follow: "I <b>follow</b> <b>{{merchant}}</b> on Instagram",
        rappel_step1_tiktok_follow: "I <b>follow</b> <b>{{merchant}}</b> on TikTok",
        rappel_step1_youtube_subscribe: "I <b>subscribe</b> to the YouTube channel",
        rappel_step1_linkedin_follow: "I <b>follow</b> <b>{{merchant}}</b> on LinkedIn",
        rappel_step1_google_review: "I leave a <b>review and a comment</b> on Google",
        rappel_step1_tripadvisor_review: "I leave a <b>review</b> on Tripadvisor",
        rappel_step1_app_download: "I <b>download</b> the app",
        rappel_step1_newsletter_signup: "I subscribe to the <b>newsletter</b>",
        rappel_step1_account_creation: "I create an <b>account</b> on the website",
        rappel_step1_instagram_story: "I share an Instagram <b>story</b>",
        rappel_step2: "I come back to the previous page or to the contest tab",
        rappel_step2_hint_back: "Back button",
        rappel_step2_hint_tabs: "Tabs / switcher",
        rappel_step3_instant: "I play and try my luck",
        rappel_step3_draw: "I'll be watching the draw result",
        verifying: "Verifying…",
        verified: "Verified",
        wheel_play_button: "Play now",
        progress_restored: "Welcome back! Your progress has been restored.",
        open_link: "Open",
        ready: "Ready to play?",
        spin: "SPIN",
        spinning: "Spinning…",
        you_won: "You won!",
        you_lost: "Not this time",
        play_again: "Play again",
        win_email_coupon:
          "You'll receive your coupon by email to redeem your gift.",
        win_thanks: "Thanks for playing!",
        win_spam_warning:
          "Heads up: the email may land in your spam folder.",
        powered: "Powered by QRISE",
        rules_link: "View game rules",
        rules_download_pdf: "Download the rules (PDF)",
        your_code: "Your code",
        copy: "Copy",
        copied: "Copied",
        redeem_at: "Redeem at",
        valid_until: "Valid until",
        valid_for_days: "Valid for {{days}} days",
        required_badge: "Required",
        optional_badge: "Optional",
        scratch_tap_to_reveal: "Tap to play",
        scratch_headline: "Scratch the card",
        scratch_start: "Start",
        scratch_loading: "Preparing…",
        scratch_here: "SCRATCH HERE",
        scratch_ready: "Ready to scratch?",
        advent_daily_badge: "One door per day",
        advent_hero_kicker: "The big day",
        advent_today_pip: "Today",
        advent_sound_on: "Turn sound on",
        advent_sound_off: "Mute sound",
        advent_free_badge: "Pick a single door",
        advent_day: "Day",
        advent_open_today: "Open today's door!",
        advent_come_back: "Today's door opened! Next door in",
        advent_next_in: "Next door in",
        advent_pick_one: "Pick your lucky door — just one!",
        advent_free_done: "Your door is opened — good luck next time!",
        advent_open_any: "Open your door!",
        advent_already_opened: "You already opened this door.",
        advent_all_opened_kicker: "Calendar complete",
        advent_all_opened: "All the doors are open! Thank you for playing with us.",
        advent_all_opened_wins_one: "You won 1 prize — find it in your emails.",
        advent_all_opened_wins_other: "You won {{count}} prizes — find them in your emails.",
        advent_all_opened_nowin: "No prize this time — see you soon for a new campaign!",
        advent_error: "This door cannot be opened right now.",
        scratch_revealing: "Revealing…",
        scratch_hint:
          "Drag your finger across the foil to uncover your prize.",
        scratch_prize: "YOUR PRIZE",
        scratch_outcome: "OUTCOME",
        penalty_aim: "Aim · Shoot",
        penalty_shot: "SHOT IN PROGRESS",
        penalty_goal: "GOAAAL !",
        penalty_save: "SAVED",
        penalty_hint: "Pick your target zone — the keeper is about to dive!",
        penalty_shot_counter: "Shot {{n}}/{{total}}",
        penalty_combo: "Combo x{{n}}",
        penalty_recap: "{{score}}/{{total}} goals · Best combo x{{best}}",
        penalty_hint_series:
          "5 shots — the keeper learns fast, vary your zones!",
        card_start: "Flip the cards",
        card_loading: "Shuffling…",
        card_ready: "Flip all 4 cards",
        card_progress: "{{count}}/4 flipped",
        card_pair_found: "Two matching cards — you win!",
        card_all_different: "Four different cards — try again",
        lottery_badge: "Prize draw",
        lottery_winners_label_one: "1 winner will be drawn",
        lottery_winners_label_other: "{{count}} winners will be drawn",
        lottery_participate_cta: "Click here to participate",
        lottery_submitting: "Submitting…",
        lottery_entered: "You're in!",
        lottery_already_entered: "You've already entered this draw.",
        lottery_already_entered_badge: "Entry already recorded",
        lottery_confirmed_badge: "Entry confirmed",
        lottery_confirmed_title: "That's it!",
        lottery_confirmed_body:
          "Keep an eye on your emails — we'll contact you if you win. Boost your odds by sharing this draw with friends.",
        lottery_share_title: "Boost your chances",
        lottery_share_body:
          "Every friend who enters via your link gives you an extra ticket in the draw.",
        lottery_share_button: "Share",
        lottery_share_text: "I just entered the {{title}} draw — try your luck!",
        lottery_share_opened: "Great! Every new friend = +1 ticket.",
        lottery_copy_error: "Could not copy",
        slot_badge: "Slot machine",
        slot_start: "Pull the lever",
        slot_loading: "Warming up…",
        slot_ready: "Ready to spin?",
        slot_spinning_reels: "Reels spinning… {{count}}/3",
        slot_triple_match: "JACKPOT! Three {{label}} — you win!",
        slot_no_match: "No match this time — try again",
        pred_badge: "Prediction",
        pred_title: "Predict the scores",
        pred_body:
          "Guess the exact score for each match. Only perfect predictions enter the draw.",
        pred_submit: "Submit my predictions",
        pred_submitting: "Submitting…",
        pred_tennis_winner: "Who wins?",
        pred_your_score: "Your prediction",
        pred_required: "Please fill in every prediction",
        pred_closed: "Predictions are closed — a match has already started.",
        pred_confirmed_title: "You're in!",
        pred_confirmed_body:
          "Results will be checked after the final whistle. Good luck!",
        pred_already: "You've already submitted your predictions.",
        pred_match_kickoff: "Kick-off",
        pred_sport_football: "Football",
        pred_sport_basketball: "Basketball",
        pred_sport_tennis: "Tennis",
        pred_vs: "vs",
        pred_score_hint: "Enter a whole number",
        gp_badge: "Guess the price",
        gp_title: "Guess the price",
        gp_body:
          "Look carefully at the item below and enter the price you think it's worth. The closest to the real price wins!",
        gp_input_label: "Your price (€)",
        gp_submit: "Submit my guess",
        gp_submitting: "Submitting…",
        gp_confirmed_title: "Your guess is in!",
        gp_confirmed_body:
          "The winner will be announced after the game ends — the guess closest to the real price wins.",
        gp_already: "You've already entered your guess.",
        gp_required: "Please enter a price",
        quiz_badge: "Quiz",
        test_mode_banner: "ADVERTISER TEST MODE — plays are not counted, anti-fraud disabled",
        waiting_opens_on: "Opens on {{date}}",
        waiting_countdown_label: "Time left before opening",
        waiting_unit_days: "days",
        waiting_unit_hours: "hours",
        waiting_unit_minutes: "min",
        waiting_unit_seconds: "sec",
        quiz_intro_title: "{{count}} questions to answer",
        quiz_intro_body:
          "Answer every question correctly to be automatically entered into the prize draw. If you slip up, you get one last attempt.",
        quiz_intro_winners_one: "1 winner drawn",
        quiz_intro_winners_other: "{{count}} winners drawn",
        quiz_intro_timer: "{{seconds}} s per question",
        quiz_start: "Start the quiz",
        quiz_progress: "Question {{current}} / {{total}}",
        quiz_single_hint: "One answer",
        quiz_multiple_hint: "Several answers possible",
        quiz_expected_count_one: "1 answer expected",
        quiz_expected_count_other: "{{count}} answers expected",
        quiz_intro_body_unlimited:
          "Answer every question correctly to be automatically entered into the prize draw. If you slip up, you can try again as many times as you like.",
        quiz_fail_retry_body_unlimited: "The questions you missed are highlighted below. Try again as many times as you like — same details, no need to fill the form again.",
        quiz_retry_sub_unlimited: "Same details, no form to fill again",
        quiz_link_default: "Learn more",
        quiz_next: "Next",
        quiz_submit: "Submit my answers",
        quiz_timer_hint: "{{seconds}} s per question — the quiz moves on when time is up.",
        quiz_checking: "Checking your answers…",
        quiz_perfect_kicker: "Perfect score!",
        quiz_score: "{{score}} / {{total}} correct answers",
        quiz_draw_entered: "You're automatically entered into the prize draw — {{count}} winner(s) will be drawn. Good luck!",
        quiz_confirmed_body_one:
          "You're automatically entered into the prize draw (1 winner). Our team will contact you if you are drawn. Boost your chances of being drawn by sharing the game on your social networks.",
        quiz_confirmed_body_other:
          "You're automatically entered into the prize draw ({{count}} winners). Our team will contact you if you are drawn. Boost your chances of being drawn by sharing the game on your social networks.",
        quiz_share_text: "I just aced the {{title}} quiz — try your luck!",
        quiz_fail_kicker: "Not quite…",
        quiz_fail_retry_body: "The questions you missed are highlighted below. You have one last attempt — same details, no need to fill the form again.",
        quiz_fail_final_body: "Thanks for playing!",
        quiz_retry_btn: "Try again",
        quiz_retry_sub: "Last attempt — same details, no form to fill again",
        quiz_no_attempts: "You've used both attempts. Thank you for taking part!",
        quiz_lose_default: "Too bad… that was your last attempt. Thanks for playing, see you soon!",
        quiz_empty: "This quiz has no questions yet.",
        ninja_badge: "Ninja Slice",
        ninja_title: "Slice the products, avoid the bombs!",
        ninja_subtitle:
          "You have {{duration}}s. +{{points}} pts per slice. Top scorers win prizes.",
        ninja_avoid_bombs: "Avoid bombs",
        ninja_combo_hint: "Combos = bonus",
        ninja_start: "Start",
        ninja_points: "points",
        ninja_bomb_hit: "Bomb hit!",
        ninja_time_up: "Time's up",
        ninja_submitted: "Score saved!",
        ninja_already_played: "You've already played.",
        ninja_winners_hint:
          "The {{count}} top scorers will win. You'll be contacted if you're in the top.",
        ninja_top3: "Top 3 live",
        ninja_no_scores: "Be the first to score!",
      },
      quiz_draw: {
        title: "Quiz prize draw",
        subtitle_one: "1 winner drawn at random among players who answered every question right. One single, definitive draw.",
        subtitle_other: "{{count}} winners drawn at random among players who answered every question right. One single, definitive draw.",
        participants: "Participants",
        eligible: "Perfect scores",
        draw_btn: "Draw winners",
        confirm_btn: "Confirm — final draw",
        cancel: "Cancel",
        drawing: "Drawing…",
        drawn_at: "Draw done on {{date}}",
        done_note: "The draw is final and cannot be redone.",
        definitive_note: "One single draw — it cannot be redone.",
        no_eligible: "No perfect score yet — nobody to draw from.",
        winners_title_one: "🏆 1 winner drawn",
        winners_title_other: "🏆 {{count}} winners drawn",
        attempts_one: "1 attempt",
        attempts_other: "{{count}} attempts",
        tickets_total: "{{count}} tickets in the urn (incl. referral bonuses)",
        winner_message_title: "Message for the winner",
        winner_message_copy: "Copy",
        winner_message_copied: "Message copied",
        winner_message_hint: "Defined in Texts → “Winner email message”. Send it to the winner by email or phone.",
      },
      draw_reveal: {
        countdown_eyebrow: "Prize draw",
        countdown_title: "Fate is about to speak…",
        drawing: "Drawing…",
        in_the_urn_one: "1 ticket in the urn",
        in_the_urn_other: "{{count}} tickets in the urn",
        winners_eyebrow: "Congratulations",
        winners_title: "And the winner is…",
        winners_title_plural: "And the winners are…",
        close: "Close",
      },
      blow: {
        intro_eyebrow: "Make a wish",
        intro_title: "Blow out the candles!",
        intro_sub: "Put out every candle before the timer runs out to reveal your gift.",
        mode_mic: "Blow into the mic",
        mode_tap: "Tap or hold the screen",
        badge_fun: "Fun",
        badge_silent: "Silent",
        mic_denied: "Microphone blocked — use tap mode instead.",
        calibration_eyebrow: "Calibration",
        calibration_title: "Stay quiet for a second…",
        calibration_sub: "We're listening to the room noise to tune your mic.",
        gauge_label: "Breath",
        mic_hint: "Hold the phone close and blow — or tap the cake",
        tap_hint: "Tap fast or hold your finger on the cake",
        revealing: "Your gift is being revealed…",
        timeout: "The breeze died down — time's up!",
        all_out: "All out!",
      },
      inapp: {
        title: "Open this page in your browser",
        subtitle:
          "To play this game, please open it in your phone's browser — quick, simple, and no redirection issues.",
        step1_a: "Tap",
        step1_b: "at the top-right of the screen",
        step2_a: "Then choose",
        step2_action: "Open in browser",
        why_label: "Why?",
        why_body:
          "In-app browsers (Instagram, Facebook, TikTok…) sometimes block redirections and logins. Opening in your real browser guarantees the best experience.",
        powered_by: "Powered by QRISE",
        arrow_label: "here!",
      },
      common: {
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        close: "Close",
        yes: "Yes",
        no: "No",
        loading: "Loading…",
        back: "Back",
        not_found: "Not found",
        upload: "Upload",
      },
      rgpd: {
        eyebrow: "GDPR data-processing agreement",
        title: "GDPR contract between QRISE and your company",
        subtitle:
          "Please read and accept the data-processing agreement before using the platform. You can reopen it at any time from your profile.",
        open_link: "GDPR contract",
        checkbox_i_accept:
          "I acknowledge having read, understood and accepted, on behalf of {{client}}, the terms of this GDPR data-processing agreement.",
        cta_accept: "Accept the contract",
        accepted_toast: "GDPR contract accepted — thank you!",
        already_accepted_title: "Contract already accepted",
        already_accepted_hint:
          "Accepted on {{date}} (version {{version}}). This document is archived on our servers.",
        card_title: "GDPR data-processing agreement",
        card_hint:
          "Consult at any time the contract binding QRISE (DEAL RUN SARL) and your company for the processing of personal data.",
        card_cta: "View the contract",
        download_pdf: "Download PDF",
        th_column: "GDPR contract",
        accepted_on: "Accepted on",
        pending: "Pending",
      },
      poster: {
        tab_label: "Poster",
        eyebrow: "AI Poster Generator",
        title: "Create your poster in one click",
        subtitle:
          "Nano Banana Pro designs a premium A4 poster for your active contest. Logo, QR code and prizes are auto-inserted — ready to print.",
        game_label: "Game / Contest",
        style_label: "Visual style",
        cta_label: "Bottom call-to-action",
        cta_hint: "Max 60 characters. Appears right below the QR code.",
        generate_btn: "Generate my poster",
        regenerate_btn: "Regenerate",
        generating: "Creating your poster…",
        generating_hint:
          "Takes ~30-45 s. The AI is composing the hero visual while we add the QR code and prizes.",
        generated_toast: "Poster ready — preview on the right.",
        download: "Download PNG",
        print: "Print",
        empty_title: "Your poster will appear here",
        empty_hint:
          "Pick a style, tweak the call-to-action, and hit Generate. The contest, prizes, logo and QR code are pulled live from your active game.",
      },
      rules: {
        title: "Game rules",
        subtitle:
          "Manage the terms and conditions that participants can consult before or after playing.",
        external_url: "External URL",
        external_url_hint: "If provided, a link to this URL is shown below the game.",

        content: "Rules content",
        placeholder: "Write your rules in Markdown, or generate a draft with AI.",
        markdown_hint: "Markdown supported (## Headings, **bold**, lists…)",
        generate: "Generate with AI",
        generating: "Generating…",
        generated: "Rules generated — review and save",
        saved: "Rules saved",
        view_btn: "View game rules",
        edit_btn: "Rules",
        manage: "Manage rules",
      },
      grand_draw: {
        title: "Grand final draw",
        subtitle:
          "Players of this game are automatically entered into a big final prize draw at the end of the campaign.",
        enable: "Enable the grand final draw",
        enable_hint: "Players are entered automatically as soon as they play.",
        winners_count: "Number of winners",
        eligibility: "Who is entered?",
        eligibility_all: "All players (winners & losers)",
        eligibility_losers: "Only losers (second chance)",
        participants: "Entrants",
        drawn_at: "Draw done on {{date}}",
        draw_btn: "Draw winners",
        confirm_btn: "Confirm — final draw",
        cancel: "Cancel",
        drawing: "Drawing…",
        draw_success: "Grand draw complete!",
        winners_title_one: "🏆 1 winner drawn",
        winners_title_other: "🏆 {{count}} winners drawn",
        definitive_note: "One single draw — it cannot be redone.",
        done_note: "The draw is final and cannot be redone.",
        no_participants: "No entrants yet.",
        merchant_locked: "Settings managed by your administrator —",
      },
      lottery: {
        btn_draw: "Draw winners",
        dialog_title: "Lottery draw",
        total_participants: "Participants",
        configured_winners: "Configured winners",
        winners_to_draw: "Number of winners to draw",
        draw_now: "Draw now",
        redraw: "Redraw",
        drawing: "Drawing…",
        draw_success: "Winners drawn!",
        winners_title_one: "🏆 1 winner selected",
        winners_title_other: "🏆 {{count}} winners selected",
        tickets: "tickets",
        drawn_at: "Last draw: {{date}}",
        distribute_now: "Distribute prizes",
        distributing: "Distributing…",
        distribute_success:
          "{{count}} winner(s) rewarded — {{emails}} email(s) sent",
        distribute_none:
          "Nobody got everything right — no prizes distributed.",
        distributed_at: "Prizes distributed: {{date}}",
        guaranteed_prize: "Guaranteed prize",
        rewarded_label: "Rewarded",
        emails_auto_note:
          "Each winner automatically receives an email with their prize claim link.",
        email_sent: "Email sent",
        email_pending: "Email pending",
        claim_until: "Claim before: {{date}}",
      },
      profile: {
        title: "Profile",
        saved: "Profile saved",
        section_display: "Display",
        section_display_hint:
          "Shown inside the QRISE platform for your account.",
        section_legal: "Legal information",
        section_pause: "Waiting page (no active game)",
        section_pause_hint:
          "Texts shown on your permanent QR link when no game is live. Leave a field empty to keep the default text.",
        pause_badge: "Badge (default: your brand name)",
        pause_title: "Title (default: “A new game is coming soon”)",
        pause_body: "Text (default: “… is preparing a new experience. Come back in a few moments…”)",
        pause_status: "Status label (default: “Paused”)",
        section_legal_hint:
          "Used by the AI to generate compliant game rules. Keep these fields up to date.",
        name: "Contact name",
        company: "Brand / trade name",
        legal_name: "Legal company name",
        address: "Registered address",
        registration_number: "Registration number (SIRET / RCS)",
        contact_email: "Contact email",
        website: "Website",
        logo: "Brand logo",
        logo_hint:
          "Shown on every game you run. Square or round artwork works best (PNG/JPG, max 2 MB).",
      },
      bg: {
        label: "Background image",
        upload: "Upload image",
        replace: "Replace",
        empty_hint: "No image · click upload",
        spec_hint:
          "Recommended 1080×1920 portrait (9:16). Large images are auto-resized and compressed.",
        spec_hint_desktop:
          "Recommended 1920×1080 landscape (16:9). Auto-resized and compressed.",
        spec_hint_tablet:
          "Recommended 1536×2048 portrait (3:4). Auto-resized and compressed.",
        spec_hint_og:
          "Recommended 1200×630. Shown when the game link is shared (WhatsApp, Facebook…).",
        spec_hint_win:
          "Animated GIF accepted. Shown in the win pop-up above the message.",
        label_desktop: "PC background (default)",
        label_tablet: "Tablet background",
        label_mobile: "Mobile background",
        responsive_title: "Background images per device",
        responsive_hint:
          "The player automatically sees the image matching their screen. The PC image is used as fallback when no tablet or mobile image is set.",
        preview_title: "Player preview",
        preview_hint:
          "Approximate render of the public game page with your backgrounds, colors and fonts.",
        preview_fallback:
          "PC image used (no background set for this device).",
        device_desktop: "PC",
        device_tablet: "Tablet",
        device_mobile: "Mobile",
        too_large: "Image is too large (max {{mb}} MB).",
        wrong_format: "Unsupported format. Use JPG, PNG or WebP.",
        process_error: "Could not process the image.",
        uploaded: "Image uploaded",
      },
      qr: {
        title: "Game QR code",
        subtitle:
          "Print it or scan it — players land straight on your game.",
        copy_url: "Copy URL",
        copied: "Copied",
        copy_error: "Could not copy URL",
        download_success: "Downloaded",
        print_hint: "PNG (1024px) is ready for print. SVG scales infinitely.",
      },
    },
  },
  fr: {
    translation: {
      status: {
        live: "En cours",
        scheduled: "Programmé",
        ended: "Terminé",
        suspended: "Suspendu",
      },
      nav: {
        features: "Fonctionnalités",
        games: "Jeux",
        pricing: "Tarifs",
        login: "Connexion",
        login_short: "Login",
        contact_short: "Contact",
        dashboard: "Tableau de bord",
        logout: "Déconnexion",
        how: "Comment ça marche",
      },
      lp: {
        nav_games: "Les jeux",
        nav_benefits: "Avantages",
        nav_pricing: "Tarifs",
        nav_contact: "Contact",
        nav_login: "Se connecter",
        nav_cta: "Lancer un jeu",
        hero_badge: "Plateforme de gamification marketing par QR code",
        hero_title_1: "Transformez chaque visite",
        hero_title_2: "en client fidèle avec la",
        hero_title_grad: "Gamification",
        hero_sub_a: "Collectez des avis Google, gagnez des followers Instagram et captez des contacts qualifiés grâce à ",
        hero_sub_bold: "14 mini-jeux premium",
        hero_sub_b: " entièrement personnalisables à votre image.",
        hero_cta_primary: "Lancez votre premier jeu",
        hero_cta_secondary: "Découvrir les avantages",
        hero_proof_games: "14 mini-jeux premium",
        hero_proof_unlimited: "Participants illimités",
        hero_proof_fraud: "Anti-triche & RGPD",
        trust_title: "Ces enseignes nous font confiance",
        games_eyebrow: "Le catalogue",
        games_title: "14 mini-jeux premium, pour chaque occasion.",
        games_sub_a: "Soldes, fêtes, anniversaires, lancement produit… il y a toujours un jeu adapté. Chacun est personnalisable : couleurs, polices, lots, probabilités et sons. ",
        games_sub_bold: "Cliquez sur un jeu pour l'essayer en conditions réelles.",
        game_try: "Tester ce jeu",
        game_more_title: "Et bientôt d'autres…",
        game_more_link: "Voir les tarifs",
        game_roue_name: "Roue de la Fortune", game_roue_desc: "Le grand classique, irrésistible",
        game_gratter_name: "Carte à gratter", game_gratter_desc: "Grattez, gagnez, revenez",
        game_slot_name: "Machine à sous", game_slot_desc: "Trois symboles, un jackpot",
        game_cartes_name: "Jeu de cartes", game_cartes_desc: "Retournez la bonne carte",
        game_mystere_name: "Boîte mystère", game_mystere_desc: "5 styles de coffres à ouvrir",
        game_tirage_name: "Tirage au sort", game_tirage_desc: "Un ou plusieurs gagnants",
        game_prix_name: "Juste Prix", game_prix_desc: "Devinez le prix du produit",
        game_ninja_name: "Ninja", game_ninja_desc: "Tranchez vos produits en vol",
        game_bougies_name: "Souffler les bougies", game_bougies_desc: "Au micro, comme un anniversaire",
        game_flappy_name: "Flappy Mascotte", game_flappy_desc: "Votre mascotte, leur record",
        game_pronos_name: "Pronostics sportifs", game_pronos_desc: "Pariez sur les vrais matchs",
        game_penalty_name: "Penalty 3D", game_penalty_desc: "Tir au but immersif",
        game_cadeau_name: "Cadeau d'inscription", game_cadeau_desc: "Lot garanti à l'inscription",
        game_avent_name: "Calendrier de l'Avent", game_avent_desc: "Une case par jour, vos clients reviennent",
        game_quiz_name: "Quiz", game_quiz_desc: "Bonnes réponses = tirage au sort",
        how_eyebrow: "Comment ça marche",
        how_title: "Du scan au retour en boutique, en 4 étapes.",
        step1_t: "Scan du QR code", step1_d: "Un QR permanent, imprimé une seule fois, réutilisable pour toutes vos campagnes.",
        step2_t: "Formulaire express", step2_d: "Prénom, email, téléphone… vous choisissez les champs. Contacts 100 % opt-in.",
        step3_t: "Actions gagnantes", step3_d: "11 actions au choix : avis Google, follow Instagram, TikTok, newsletter… avant même de jouer.",
        step4_t: "Jeu & récompense", step4_d: "Le client joue, gagne, et reçoit son coupon par email. Il revient dépenser.",
        ctas_eyebrow: "Les actions gagnantes",
        ctas_title: "11 CTA au choix, avant chaque partie.",
        ctas_sub: "Pour débloquer sa participation, le joueur réalise l'action de votre choix : un avis, un abonnement, une inscription… Combinez-en autant que vous voulez, ils sont illimités.",
        cta_google_review_label: "Avis Google", cta_google_review_benefit: "Grimpez dans les résultats de recherche locaux et rassurez vos futurs clients.",
        cta_instagram_follow_label: "Follow Instagram", cta_instagram_follow_benefit: "Gagnez des abonnés qui reverront vos posts, stories et promotions.",
        cta_facebook_like_label: "Like Facebook", cta_facebook_like_benefit: "Élargissez votre communauté et la portée de chaque publication.",
        cta_tiktok_follow_label: "Follow TikTok", cta_tiktok_follow_benefit: "Touchez une audience jeune et donnez de la viralité à vos vidéos.",
        cta_youtube_subscribe_label: "Abonnement YouTube", cta_youtube_subscribe_benefit: "Construisez une audience durable pour vos contenus vidéo.",
        cta_linkedin_follow_label: "Follow LinkedIn", cta_linkedin_follow_benefit: "Renforcez votre image professionnelle et votre réseau B2B.",
        cta_tripadvisor_review_label: "Avis Tripadvisor", cta_tripadvisor_review_benefit: "Attirez touristes et visiteurs qui choisissent grâce aux avis.",
        cta_instagram_story_label: "Story Instagram", cta_instagram_story_benefit: "Vos clients deviennent vos ambassadeurs auprès de leurs proches.",
        cta_app_download_label: "Téléchargement d'app", cta_app_download_benefit: "Installez votre application sur le téléphone de chaque joueur.",
        cta_newsletter_signup_label: "Inscription newsletter", cta_newsletter_signup_benefit: "Constituez une base email opt-in, réactivable à volonté et sans coût.",
        cta_account_creation_label: "Création de compte", cta_account_creation_benefit: "Transformez les joueurs en clients enregistrés sur votre site.",
        cta_unlimited_title: "Cumulables & illimités",
        cta_unlimited_desc: "Combinez plusieurs actions sur un même jeu — sans limite ni surcoût.",
        adv_eyebrow: "Les avantages",
        adv_title: "Conçu pour les commerçants, propulsé par l'IA.",
        adv_ocr_title: "Preuve d'achat par OCR IA",
        adv_ocr_desc: "Exigez un ticket de caisse pour jouer : notre intelligence artificielle lit automatiquement le montant, la date et le nom de l'enseigne. Zéro vérification manuelle, zéro fraude.",
        adv_ocr_chip1: "Montant minimum", adv_ocr_chip2: "Ancienneté du ticket", adv_ocr_chip3: "Nom de l'enseigne",
        adv_qr_alt: "Scan d'un QR code",
        adv_qr_title: "QR Code permanent",
        adv_qr_desc: "Imprimé une seule fois, il pointe toujours vers votre jeu actif. Changez de campagne sans réimprimer.",
        adv_custom_title: "Personnalisation totale",
        adv_custom_desc: "13 polices, couleurs, fonds par appareil (PC, tablette, mobile), sons, confettis à vos couleurs… le jeu devient une extension de votre marque.",
        adv_fraud_title: "Anti-triche intégré",
        adv_fraud_desc: "Une participation par personne et par jeu : empreinte navigateur, email et téléphone vérifiés — même en navigation privée.",
        adv_email_title: "Gains automatisés",
        adv_email_desc: "Coupons envoyés par email automatiquement, avec dates de validité, instructions par lot et votre message personnalisé.",
        adv_turnkey_title: "Jeu clé en main",
        adv_turnkey_desc: "Nos équipes paramètrent entièrement votre jeu : lots, probabilités, visuels, règlement. Vous le recevez prêt à lancer — il ne vous reste qu'à afficher le QR code.",
        adv_lottery_title: "Tirage au sort en un clic",
        adv_lottery_desc: "L'outil gère votre tirage au sort : un clic, et les gagnants sont désignés aléatoirement et équitablement parmi les participants — liste des gagnants instantanée.",
        adv_claims_title: "Retrait des lots géré",
        adv_claims_desc: "La récupération des lots est pilotée par l'outil : coupon unique par gagnant, validation en boutique et suivi en temps réel des lots retirés ou en attente.",
        adv_data_title: "Data, analytics & RGPD",
        adv_data_desc: "Participations, gagnants, stocks restants en temps réel. Exportez vos contacts opt-in en un clic — 100 % conforme RGPD, données hébergées en Europe.",
        adv_stat1_l: "d'avis Google", adv_stat2_l: "d'opt-in marketing", adv_stat3_l: "pour lancer un jeu",
        opt_eyebrow: "Options à la carte",
        opt_title: "Chaque jeu, vos règles.",
        opt_sub_a: "Activez en un clic des conditions de participation et des champs supplémentaires — disponibles sur ",
        opt_sub_bold: "tous les jeux",
        opt_sub_b: ", sans supplément.",
        opt_li1: "Téléphone requis, optionnel ou masqué", opt_li2: "Consentement marketing opt-in (RGPD)", opt_li3: "Combinables entre elles, jeu par jeu",
        opt_mock_title: "Conditions de participation",
        opt_receipt_title: "Ticket de caisse obligatoire",
        opt_receipt_desc: "Le participant importe ou photographie son ticket avant de jouer. L'OCR par IA extrait le montant, la date et le nom du commerce pour contrôle.",
        opt_address_title: "Collecter l'adresse postale",
        opt_address_desc: "Rue, code postal, ville — idéal quand vous expédiez un cadeau physique : stickers, mugs, t-shirts…",
        opt_birthdate_title: "Demander la date de naissance",
        opt_birthdate_desc: "Enrichissez vos contacts et déclenchez des campagnes d'anniversaire personnalisées.",
        ben_google_title: "Boostez vos avis Google",
        ben_google_desc: "Demandez un avis avant chaque partie. Nos enseignes multiplient leurs avis par 5 dès le premier mois — et grimpent dans les résultats locaux.",
        ben_google_cta: "Collecter plus d'avis",
        ben_sales_title: "Générez plus de ventes",
        ben_sales_desc: "Chaque gagnant reçoit un coupon à venir utiliser en boutique. Le jeu crée le trafic, le coupon crée le passage en caisse.",
        ben_sales_cta: "Faire revenir mes clients",
        ben_contacts_title: "Captez des contacts qualifiés",
        ben_contacts_desc: "Prénom, email, téléphone, consentement marketing : constituez une base de contacts locale et réactivable, campagne après campagne.",
        ben_contacts_cta: "Construire ma base clients",
        price_eyebrow: "Tarifs",
        price_title: "Des tarifs simples, un ROI immédiat.",
        price_sub: "Payez par jeu, pas par participant. Quel que soit votre trafic, le prix ne bouge pas.",
        price_recommended: "Recommandé",
        price_plan1: "Avec engagement",
        price_unit: "HT / jeu",
        price_plan1_desc_a: "Durée de 1 mois maximum par jeu, sous réserve d'un engagement de ",
        price_plan1_desc_bold: "minimum 4 jeux dans l'année",
        price_plan1_cta: "S'engager et économiser 50%",
        price_plan2: "Sans engagement — One Shot",
        price_plan2_desc_a: "Durée de 1 mois maximum par jeu. ",
        price_plan2_desc_bold: "Aucun engagement",
        price_plan2_desc_b: " : idéal pour tester ou pour une opération ponctuelle.",
        price_plan2_cta: "Lancer un jeu One Shot",
        price_b1: "Nombre de participants illimités", price_b2: "Jeux illimités", price_b3: "CTA illimités", price_b4: "Analytics avancés",
        price_footnote: "Participants illimités, jeux illimités et CTA illimités sur les deux formules. Prix hors taxes.",
        contact_eyebrow: "Contact",
        contact_title: "Parlons de votre projet.",
        contact_sub: "Une question sur les jeux, les tarifs ou une opération sur mesure ? Écrivez-nous — nous répondons sous 24 h ouvrées.",
        contact_li1: "Démo personnalisée de la plateforme", contact_li2: "Accompagnement au lancement de votre 1er jeu", contact_li3: "Devis pour opérations multi-boutiques",
        contact_success_title: "Message envoyé !",
        contact_success_body: "Merci {{name}}, nous revenons vers vous très vite à l'adresse {{email}}.",
        contact_ph_name: "Votre nom *", contact_ph_email: "Votre email *", contact_ph_company: "Société (optionnel)", contact_ph_phone: "Téléphone (optionnel)", contact_ph_message: "Votre message *",
        contact_sending: "Envoi en cours…", contact_send: "Envoyer le message",
        contact_privacy: "Vos données ne servent qu'à vous répondre. Jamais partagées.",
        contact_err_required: "Nom, email et message sont obligatoires.",
        contact_err_generic: "Une erreur est survenue. Réessayez dans un instant.",
        final_title_1: "Votre prochain client est déjà",
        final_title_2: "devant votre ",
        final_title_grad: "QR code",
        final_sub: "Lancez votre premier jeu en quelques minutes. Participants illimités, personnalisation totale, résultats mesurables dès la première semaine.",
        final_cta: "Démarrer maintenant",
        footer_login: "Connexion",
        footer_copy: "QRISE — qrise-game.fr · Données hébergées en Europe · RGPD",
        footer_legal: "Mentions légales", footer_terms: "Conditions d'utilisation", footer_cgv: "CGV", footer_privacy: "Politique de confidentialité",
        footer_publisher: "QRISE est édité par DEAL RUN — SARL · SIREN 895 350 783",
        lang_label: "Langue",
      },
      landing: {
        badge: "La gamification qui convertit",
        title_a: "Transformez chaque scan en",
        title_b: "client fidèle",
        subtitle:
          "QRISE permet aux entreprises de lancer des jeux interactifs premium pour capter des leads, booster les avis et la portée sociale.",
        stats_plays: "Parties jouées",
        stats_conv: "Conversion moy.",
        stats_brands: "Marques actives",
        // New premium landing
        eyebrow: "QRISE · MOTEUR GAMIFICATION COMMERCE",
        learn_more: "En savoir plus",
        try_demo: "Tester la démo",
        book_demo: "Réserver ma démo",
        see_terms: "Voir les conditions",
        see_features: "Voir les fonctionnalités",
        promo_text: "Boostez votre taux de conversion de 38 %. Réservez votre démo live aujourd'hui.",
        promo_cta: "Réserver une démo",
        apple_hero_title_v2: "Vos clients jouent.",
        apple_hero_title_v2_2: "Vous encaissez.",
        apple_hero_sub_v2: "11 jeux interactifs. 11 objectifs marketing. Un seul QR code permanent.",
        apple_hero_sub_v2_2: "+38 % de conversion · 87 % d'ouverture email · livré en moins de 60 secondes.",
        hero_proof_1: "Sans engagement",
        hero_proof_2: "Sans CB",
        hero_proof_3: "Démo de 15 minutes",
        apple_hero_title: "QRISE",
        apple_hero_sub: "Onze jeux. Un QR code. +38 % de conversion garantie.",
        apple_hero_tile_title_v2: "La Roue qui rapporte.",
        apple_hero_tile_sub_v2: "Triplez votre trafic quotidien. Captez 100 % des leads.",
        apple_hero_tile_title: "Roue de la Fortune",
        apple_hero_tile_sub: "Triplez le trafic quotidien de votre point de vente avec un seul QR code permanent.",
        ctas_title_v2: "Un jeu = un objectif marketing.",
        ctas_sub_v2: "Conditionnez la participation à un like, un avis, un abonnement ou un téléchargement. Chaque partie devient un levier de croissance.",
        ctas_group_social: "Réseaux sociaux",
        ctas_group_reviews: "Avis & réputation",
        ctas_group_growth: "Acquisition & croissance",
        cta_facebook_like_sales: "Multipliez votre communauté de fans.",
        cta_instagram_follow_sales: "Convertissez les visiteurs en abonnés IG.",
        cta_instagram_story_sales: "Gagnez en reach UGC massif en 24h.",
        cta_tiktok_follow_sales: "Captez la Gen Z et la viralité.",
        cta_youtube_subscribe_sales: "Construisez votre audience YouTube sans effort.",
        cta_linkedin_follow_sales: "Boostez votre notoriété B2B.",
        cta_google_review_sales: "Grimpez dans la recherche locale. Chaque étoile = +9 % de conversion.",
        cta_tripadvisor_review_sales: "Dominez le secteur touristique. 5 étoiles à la demande.",
        cta_newsletter_signup_sales: "Construisez une base de contacts rentables.",
        cta_account_creation_sales: "Convertissez les visiteurs en clients identifiés, pas en trafic anonyme.",
        cta_app_download_sales: "Multipliez les installs mobile sans budget ads.",
        marquee_eyebrow: "240+ commerçants leur font déjà confiance",
        testi_eyebrow: "ILS EN PARLENT MIEUX QUE NOUS",
        testi_title: "Des commerçants qui ont arrêté de payer la pub.",
        testi1_q: "On a doublé nos avis Google en 6 semaines. Les clients adorent l'animation et reviennent jouer chaque semaine.",
        testi2_q: "Notre QR code en caisse nous rapporte plus de 200 inscriptions newsletter par mois. Sans effort, sans budget pub.",
        testi3_q: "La Mystery Box a fait exploser notre engagement Instagram. +47 % de followers en deux mois.",
        cta_guarantee_badge: "GARANTIE 100 % SATISFAIT — OU REMBOURSÉ",
        apple_cta_title_v2: "Vos concurrents jouent déjà.",
        apple_cta_title_v2_2: "Et vous ?",
        apple_cta_sub_v2: "+38 % de conversion en 15 minutes de démo. Sans engagement, sans CB, sans surprise.",
        cta_proof_1: "Live en moins de 60 secondes",
        cta_proof_2: "RGPD-conforme",
        cta_proof_3: "Bilingue FR / EN",
        apple_mystery_sub: "Taux d'ouverture 87 %. La mécanique qui transforme un scan en lead qualifié.",
        apple_scratch_sub: "Jusqu'à 5 minutes d'engagement. Effet premium qui valorise vos lots.",
        apple_antireplay_sub: "Triple garde appareil + téléphone + email. Zéro fraude, zéro perte.",
        apple_receipts_sub: "GPT-Vision valide chaque ticket côté serveur. Achats hors politique rejetés automatiquement.",
        apple_flappy_sub: "Le tournoi qui les fait revenir chaque jour. Mascotte custom, classement live.",
        apple_mobile_sub: "Fonctionne parfaitement dans les navigateurs in-app Facebook & Instagram. 100 % de taux de complétion.",
        apple_analytics_sub: "Tableau de bord temps réel. Conversions, retraits, ROI — tout sur un écran.",
        apple_exports_sub: "Vrai export XLSX en un clic. À glisser dans votre CRM, sans tuyauterie.",
        apple_cta_title: "Lancez-vous aujourd'hui.",
        apple_cta_sub: "+38 % de conversion en 15 minutes de démo. Sans engagement, sans CB.",
        all_games_title: "Onze jeux. Une seule plateforme.",
        all_games_sub: "Choisissez la mécanique qui colle à votre marque et lancez-la en quelques minutes.",
        stat_conv_label_long: "de conversion en moyenne",
        stat_games_label_long: "mécaniques de jeu",
        stat_plays_label_long: "parties jouées",
        stat_setup_label_long: "pour lancer un jeu",
        sales_spin_wheel_desc: "Suspense visuel à chaque tour. Le joueur reste 3× plus longtemps.",
        sales_mystery_box_desc: "Code 6 chiffres par email. Taux d'ouverture 87 %.",
        sales_scratch_card_desc: "Effet de grattage tactile. Premium, coût par partie minime.",
        sales_lottery_draw_desc: "Gros lots, parrainage viral intégré.",
        sales_slot_machine_desc: "Trois rouleaux, dopamine pure. Gain dévoilé instantanément.",
        sales_ninja_desc: "Jeu de skill. Idéal pour les campagnes tournoi.",
        sales_flappy_mascotte_desc: "Boucle de fidélisation quotidienne. Ils reviennent chaque jour.",
        sales_blow_candles_desc: "Souffle dans le micro. Effet wow garanti aux anniversaires.",
        sales_card_game_desc: "Memory matching. Engagement cognitif, fatigue minimale.",
        sales_prediction_match_desc: "Pronostics sport en direct. Pic de trafic avant le coup d'envoi.",
        sales_guess_price_desc: "Pronostic au plus juste. Mécanique de qualification de lead express.",
        hero_eyebrow: "GAMIFICATION COMMERCE PREMIUM",
        hero_overline: "QRISE / GAMIFICATION OS",
        hero_title_a: "Nous avons réinventé",
        hero_title_b: "la fidélité",
        hero_title_dot: ".",
        hero_title_c: "Par le jeu.",
        hero_scroll: "Scrollez pour explorer",
        trust_eyebrow: "ILS NOUS FONT CONFIANCE",
        benefit1: "pour un engagement automatisé maximal.",
        benefit1_bold: "Une plateforme unique",
        benefit1_desc:
          "Onze mécaniques de jeu, un QR code permanent par marchand. Triple anti-rejeu device + téléphone + email. OCR GPT-Vision qui valide chaque ticket de caisse côté serveur. Chaque partie scorée, attribuée et exportée en quelques secondes.",
        benefit2: "scalable, sans friction.",
        benefit2_bold: "Opération",
        benefit2_desc:
          "Conçu pour un onboarding marchand sans friction. Emails de gain brandés livrés en quelques secondes via Resend, exports RGPD masqués, contrat signé téléchargeable, bilingue FR/EN, mobile-first — bloqueur navigateur in-app Facebook inclus.",
        benefit3: "ROI répétable.",
        benefit3_bold: "ROI rapide,",
        benefit3_desc:
          "Exports Excel réels, analytics temps réel, CTAs viraux (follow, avis, partage) conditionnels par mécanique. Prêt à déployer dès le jour 1, scalable sur des centaines de points de vente sans surcoût opérationnel.",
        os_eyebrow: "C'est ça le",
        os_title: "QRISE OS",
        stat_games_label: "JEUX",
        stat_plays_label: "PARTIES",
        stat_conv_label: "CONV %",
        games_title_a: "Onze mécaniques.",
        games_title_b: "Un seul playbook.",
        features_title_a: "Pensé pour les opérateurs.",
        features_title_b: "Adoré des joueurs.",
        benefits_title_a: "Un pont intelligent",
        benefits_title_b: "qui connecte naturellement",
        benefits_title_c: "le passage en caisse au plaisir",
        final_title_a: "Parlons-en",
        final_title_b: "À votre rythme.",
        hero_line1: "Faites de chaque scan",
        hero_line2_italic: "un coup gagnant.",
        hero_line2_bold: "qui rapporte",
        hero_sub:
          "Onze jeux interactifs premium, un unique QR code permanent. Captez des leads qualifiés, récompensez vos meilleurs clients, et transformez chaque passage en caisse en expérience mémorable.",
        hero_cta_primary: "Contactez-nous",
        hero_cta_secondary: "Tester la démo live",
        hero_badge: "Live · 1 204 parties dans la dernière heure",
        final_eyebrow: "PRÊT À JOUER",
        final_title: "Lancez votre jeu",
        final_title_italic: "une expérience mémorable.",
        final_title_bold: "aujourd'hui.",
        final_sub: "Une démo live de 15 minutes, sans engagement.",
        stat_plays: "Parties jouées",
        stat_conv: "Conversion moyenne",
        stat_brands: "Marques à bord",
        features_eyebrow: "§ 03 — LE PRODUIT",
        features_title: "Des mécaniques ciselées. Des résultats sérieux.",
        features_sub:
          "Onze mécaniques, un système d'actions conditionnelles, analytics temps réel — pour les opérateurs qui aiment la finition.",
        feat_setup_title: "Lancez en quelques minutes",
        feat_setup_desc:
          "Segments, lots, CTA — tout se configure depuis un admin épuré. Un QR permanent par marchand, en un clic.",
        feat_receipts_title: "Preuve d'achat OCR",
        feat_receipts_desc:
          "Le joueur photographie son ticket de caisse — l'OCR GPT-Vision extrait montant, date, commerce et rejette les tickets hors politique côté serveur.",
        feat_antireplay_title: "Anti-rejeu & RGPD",
        feat_antireplay_desc:
          "Triple garde appareil + téléphone + email par jeu, contrat RGPD signé téléchargeable, exports masqués pour les leads non opt-in.",
        feat_branded_email_title: "Emails de gain brandés",
        feat_branded_email_desc:
          "Templates Resend éditoriaux avec logo marchand, livraison quasi instantanée, headers transactionnels — le gagnant reçoit son lot en quelques secondes.",
        feat_exports_title: "Exports Excel réels",
        feat_exports_desc:
          "Export XLSX en un clic avec infos participant, CTA complétés, OCR ticket de caisse et statut redemption — jamais de CSV-only.",
        feat_bilingual_title: "Bilingue FR / EN",
        feat_bilingual_desc:
          "Chaque jeu, email, page légale et écran admin existe dans les deux langues, avec un bouton de bascule unique.",
        feat_targeting_title: "Leads qualifiés",
        feat_targeting_desc:
          "Nom, email, téléphone obligatoires avant de jouer. Opt-in RGPD, exports masqués, CSV et XLSX impeccables.",
        feat_sharing_title: "Moteur viral intégré",
        feat_sharing_desc:
          "Conditionnez vos jeux à un follow, un avis, un parrainage. Chaque partage, chaque conversion tracés.",
        feat_analytics_title: "Analytics temps réel",
        feat_analytics_desc:
          "Parties, conversions, CTA, retraits — chaque signal sur un seul tableau, magnifique.",
        feat_mobile_first_title: "100 % mobile-first",
        feat_mobile_first_desc:
          "Tous les jeux tournent parfaitement sur les navigateurs in-app iPhone, avec un bloqueur intelligent qui guide les utilisateurs Facebook / Instagram vers le vrai navigateur.",
        games_eyebrow: "§ 01 — MÉCANIQUES",
        games_title: "Onze façons de jouer. Une stack premium.",
        games_sub:
          "Les onze mécaniques sont disponibles aujourd'hui — même admin, même QR, même data layer.",
        game_spin_wheel_desc: "Pointeur spectaculaire, tension maximale.",
        game_scratch_card_desc: "Révélation tactile, éclat argenté.",
        game_mystery_box_desc: "Code 6 chiffres par email, ouverture 3D premium.",
        game_slot_machine_desc: "Trois rouleaux, énergie arcade.",
        game_card_game_desc: "Retournez, associez, gagnez.",
        game_lottery_draw_desc: "Tirage pondéré avec parrainages viraux.",
        game_flappy_mascotte_desc: "Tournoi avec leaderboard, mascotte custom.",
        game_blow_candles_desc: "Soufflez dans le micro pour éteindre les bougies.",
        game_prediction_match_desc: "Pronostics sport en direct, sans-faute gagnant.",
        game_guess_price_desc: "Le pronostic le plus proche du prix secret gagne.",
        game_ninja_desc: "Découpe style Fruit-Ninja, leaderboard live.",
        spin_wheel: "Roue de la Fortune",
        scratch_card: "Carte à Gratter",
        advent_calendar: "Calendrier de l'Avent",
        mystery_box: "Boîte mystère",
        flappy_mascotte: "Flappy Mascotte",
        blow_candles: "Soufflez les bougies",
        lottery_draw: "Tirage au sort",
        prediction_match: "Pronostics",
        card_game: "Memory",
        slot_machine: "Machine à Sous",
        guess_price: "Juste Prix",
        ninja: "Ninja Slice",
        // Short aliases used across dashboards
        game_spin: "Roue de la Fortune",
        game_scratch: "Carte à Gratter",
        game_card: "Memory",
        game_slot: "Machine à Sous",
        game_lottery: "Tirage au sort",
        game_prediction: "Pronostics",
        game_price: "Juste Prix",
        game_ninja: "Ninja Slice",
        game_blow_candles: "Souffle les bougies",
        game_flappy: "Flappy Mascotte",
        game_mystery: "Boîte mystère",
        game_penalty: "Tir au but",
        game_registration_gift: "Inscription cadeau",
        registration_gift: "Inscription cadeau",
        game_avent: "Calendrier de l'Avent",
        game_quiz: "Quiz",
        soon: "Bientôt",
        live: "Disponible",
        ctas_eyebrow: "§ 02 — STACK CTA SOCIALES",
        ctas_title: "Onze leviers pour transformer l'attention en action.",
        ctas_sub:
          "Conditionnez chaque jeu aux actions qui font vraiment grandir votre business. Chaque CTA peut être obligatoire ou optionnel, avec deep-linking mobile intelligent.",
        cta_group_social: "Abonnements sociaux",
        cta_group_reviews: "Avis & confiance",
        cta_group_growth: "Acquisition & CRM",
        cta_facebook_like: "Like votre page Facebook",
        cta_instagram_follow: "Follow Instagram",
        cta_tiktok_follow: "Follow TikTok",
        cta_youtube_subscribe: "Abo. YouTube",
        cta_linkedin_follow: "Follow LinkedIn",
        cta_google_review: "Avis Google",
        cta_tripadvisor_review: "Avis Tripadvisor",
        cta_app_download: "Télécharger l'app",
        cta_newsletter_signup: "Newsletter",
        cta_account_creation: "Création de compte",
        cta_instagram_story: "Partage en Story Instagram",
        ctas_footer: "Obligatoire ou optionnel · Deep-link mobile intelligent · Vérification server-side",
        play_demo: "Tester la démo",
        how_eyebrow: "§ 04 — COMMENT ÇA MARCHE",
        how_title: "Du zéro au jackpot en trois mouvements.",
        how_sub:
          "Pas de SDK. Aucune ligne de code. Un QR permanent, un admin magnifique, un portail de retrait pour vos gagnants.",
        step1_title: "Configurer",
        step1_desc:
          "Choisissez la mécanique, uploadez votre marque, définissez lots et CTA. Opt-in RGPD intégré.",
        step2_title: "Lancer",
        step2_desc:
          "Imprimez votre QR permanent une fois. Vitrine, tickets, packaging — il ne change jamais.",
        step3_title: "Récompenser",
        step3_desc:
          "Les gagnants retirent leur lot depuis le portail, vous exportez les leads, on trace les partages.",
        social_eyebrow: "§ 05 — ILS NOUS FONT CONFIANCE",
        social_title: "Retail, hôtellerie, beauté — ils lancent plus vite avec QRISE.",
        testimonial_1:
          "On a déployé une carte à gratter en 15 minutes et collecté 2 400 numéros opt-in en un weekend.",
        testimonial_1_author: "Léa · Head of Growth, Maison Clément",
        testimonial_2:
          "QRISE est la seule stack de gamification aussi soignée que notre app flagship.",
        testimonial_2_author: "Marc · Directeur CRM, Aurore Retail",
        cta_eyebrow: "§ 06 — PRÊT ?",
        cta_title:
          "Prêt à transformer votre marketing en terrain de jeu ?",
        cta_sub:
          "Essai gratuit. Sans carte bancaire. Votre QR permanent vous attend.",
        cta_primary: "Créer mon compte",
        cta_secondary: "Tester la démo",
        footer_rights: "Tous droits réservés.",
      },
      auth: {
        title: "Bon retour",
        subtitle: "Connectez-vous à votre espace QRISE",
        email: "Email",
        password: "Mot de passe",
        login: "Se connecter",
        demo_admin: "Démo admin",
        demo_merchant: "Démo marchand",
        loading: "Connexion…",
        quick_fill: "Remplissage rapide",
        tagline_title:
          "La gamification premium pour les marques en croissance.",
        tagline_body:
          "Lancez des campagnes interactives élégantes, captez des leads qualifiés et mesurez chaque clic en temps réel.",
        tagline_footer: "Transformer les scans en fidélité.",
      },
      dashboard: {
        overview: "Vue d'ensemble",
        games: "Jeux",
        merchants: "Marchands",
        participants: "Participants",
        analytics: "Analytics",
        settings: "Paramètres",
        welcome: "Bienvenue",
        role_admin: "Admin",
        role_merchant: "Marchand",
        kpi_plays: "Parties totales",
        kpi_leads: "Leads capturés",
        kpi_conversion: "Conversion",
        kpi_games: "Jeux actifs",
        kpi_merchants: "Marchands",
        timeseries: "Parties sur 14 jours",
        cta_performance: "Performance des CTA",
        per_game: "Performance par jeu",
        no_data: "Aucune donnée",
        loading: "Chargement…",
        back: "Retour",
        new_game: "Nouveau jeu",
        new_merchant: "Nouveau marchand",
        copy_link: "Copier le lien",
        copied: "Copié",
        share_link_hint: "Pour WhatsApp & réseaux sociaux (aperçu avec image)",
        copy_share_link: "Copier le lien réseaux",
        qr: "QR",
        export_csv: "Exporter CSV",
        export_xlsx: "Exporter Excel",
        export_json: "Exporter JSON",
        export_failed: "Export impossible",
        search: "Rechercher…",
        all_games: "Tous les jeux",
        th_game: "Jeu",
        th_plays: "Parties",
        th_wins: "Gains",
        th_conversion: "Conversion",
        th_name: "Nom",
        th_company: "Société",
        th_email: "Email",
        th_games: "Jeux",
        th_date: "Date",
        th_phone: "Téléphone",
        th_receipt: "Ticket",
        th_result: "Résultat",
        th_win: "Gain",
        th_optin: "Opt-in",
        opt_in_yes: "Accepte les communications marketing",
        opt_in_no: "N'a pas opt-in",
        th_redeemed: "Retiré",
        th_predictions: "Pronostics",
        th_score: "Score",
        score_unit: "pts",
        view_predictions: "Voir pronostics",
        predictions_modal_title: "Pronostics du participant",
        predictions_modal_loading: "Chargement…",
        predictions_modal_empty: "Aucun pronostic enregistré pour ce participant.",
        predictions_match: "Match",
        predictions_pick: "Pronostic",
        predictions_real: "Réel",
        predictions_correct: "Correct",
        predictions_wrong: "Incorrect",
        predictions_pending: "En attente",
        mark_redeemed: "Marquer comme retiré",
        confirm_mark_redeemed: "Marquer ce lot comme retiré par le client ?",
        th_shipping: "Expédition",
        th_address: "Adresse",
        shipping_to_ship: "À expédier",
        shipping_shipped: "Expédié",
        shipping_delivered: "Livré",
        mark_shipped: "Marquer expédié",
        mark_delivered: "Marquer livré",
        confirm_mark_shipped: "Marquer ce cadeau comme expédié au client ?",
        confirm_mark_delivered: "Marquer ce cadeau comme livré au client ?",
        marked_shipped: "Marqué comme expédié",
        marked_delivered: "Marqué comme livré",
        th_antirejeu: "Anti-rejeu",
        receipt_dialog_title: "Preuve d'achat",
        receipt_confidence: "Confiance {{value}}%",
        receipt_open_full: "Ouvrir l'image d'origine →",
        reset_fp: "Réinitialiser",
        reset_fp_hint:
          "Permettre à ce participant (même IP + appareil) de rejouer à ce jeu-concours. Utile en cas de faux positif.",
        confirm_reset_fp:
          "Réinitialiser l'anti-rejeu pour ce participant ? Il pourra à nouveau tenter sa chance sur ce jeu-concours.",
        fp_reset_done: "Anti-rejeu réinitialisé",
        fp_reset_done_badge: "Réinitialisé",
        select_all_participants: "Tout sélectionner",
        select_participant: "Sélectionner ce participant",
        delete_selected: "Supprimer ({{count}})",
        delete_participant: "Supprimer ce participant",
        confirm_delete_participants:
          "Supprimer définitivement {{count}} participant(s) ? Cette action est irréversible — leurs participations, lots et tickets de tirage seront perdus.",
        participants_deleted: "{{count}} participant(s) supprimé(s)",
        marked_redeemed: "Marqué comme retiré",
        badge_redeemed: "Retiré",
        badge_active: "Actif",
        badge_off: "Inactif",
        badge_win: "Gagné",
        badge_lose: "Perdu",
        badge_required: "Requis",
        badge_optional: "Optionnel",
        plays_count: "{{count}} parties",
        unassigned: "Non assigné",
        confirm_delete_game: "Supprimer ce jeu ?",
        confirm_delete_merchant: "Supprimer ce marchand ?",
        confirm_duplicate_game:
          "Dupliquer ce jeu ? La copie sera créée désactivée.",
        game_created: "Jeu créé",
        game_deleted: "Jeu supprimé",
        game_duplicated: "Jeu dupliqué — édition de la nouvelle copie",
        duplicate: "Dupliquer",
        duplicate_hint: "Crée une copie désactivée de ce jeu",
        duplicate_dialog_title: "Dupliquer ce jeu",
        duplicate_dialog_body:
          "La copie sera créée désactivée, prête à être ajustée. Lots et CTAs conservés ; participants et gagnants non copiés.",
        duplicate_assign_to: "Assigner à l'enseigne",
        duplicate_select_merchant: "Choisir l'enseigne",
        duplicate_same_merchant: "Même enseigne",
        duplicate_merchant_switch_warning: "La copie sera assignée à",
        duplicate_merchant_switch_note:
          "Pense à ajuster le règlement, les CTAs et les codes coupons si nécessaire.",
        duplicate_confirm_btn: "Dupliquer",
        merchant_created: "Marchand créé",
        merchant_deleted: "Marchand supprimé",
        merchant_slug_saved: "URL mise à jour",
        th_permanent_qr: "QR permanent",
        permanent_qr_for: "QR code permanent pour",
        permanent_qr_badge: "Votre QR code permanent",
        permanent_qr_title: "Un seul QR. Tous vos jeux. À vie.",
        permanent_qr_body:
          "C'est le QR code à imprimer dans votre boutique {{brand}}. Il reste identique d'une campagne à l'autre — dès que vous lancez un nouveau jeu, ce QR redirige automatiquement vos clients vers le jeu en cours.",
        download_qr: "Télécharger le QR",
        preview_url: "Aperçu",
        copy_error: "Impossible de copier",
        your_brand: "votre enseigne",
        active_game_label: "Jeu actif : {{title}}",
        no_active_game: "Aucun jeu actif pour le moment",
        game_activated: "Jeu activé",
        game_deactivated: "Jeu désactivé",
        toggle_activate_tooltip: "Cliquez pour activer ce jeu",
        toggle_deactivate_tooltip: "Cliquez pour désactiver ce jeu",
        th_status: "Statut",
        th_leads: "Leads",
        th_last_play: "Dernière activité",
        th_total: "Total",
        search_participants: "Rechercher par nom, email, téléphone, lot…",
        no_search_match: "Aucun participant ne correspond à votre recherche.",
        th_dates: "Dates",
        no_dates: "Aucune date définie",
        dates_tooltip: "Date de début → Date de fin (GMT+4)",
        filter_by_merchant: "Filtrer par commerçant",
        all_merchants: "Tous les commerçants",
        unassigned_merchant: "Non assigné",
        filter_by_status: "Filtrer par statut",
        all_statuses: "Tous les statuts",
        status_active: "Actif",
        status_inactive: "Inactif",
        view_participants: "Participants",
        top_merchants_title: "Top commerçants · 7 jours",
        top_merchants_subtitle: "Les enseignes les plus actives cette semaine",
        top_merchants_empty: "Aucune participation sur les 7 derniers jours",
        rank: "Rang",
        plays_7d: "{{count}} parties",
        leads_7d: "{{count}} leads",
        conversion_short: "Conv.",
      },
      probability_calc: {
        title: "Calculette de probabilités",
        subtitle: "Évite le piège des probabilités cumulées",
        current_cumul: "cumulé actuellement",
        detection: "Détection automatique",
        premium_lots: "lot(s) premium",
        premium_def: "gagnants + stock limité + disponibles",
        consolation_lots: "lot(s) de consolation",
        consolation_def: "le reste absorbe les pourcentages",
        depleted_lots: "lot(s) épuisé(s)",
        depleted_def: "gardés à 0 % (déjà gagnés)",
        no_premium:
          "Aucun lot premium détecté. Active 'Gagnant' et définis une 'Quantité initiale' sur les lots à distribuer.",
        plays_expected: "Plays attendus",
        plays_hint:
          "Estimation totale de participations sur toute la campagne.",
        lots_to_distribute: "Lots à distribuer",
        lots_hint: "Combien de lots premium tu veux idéalement distribuer.",
        recommendation: "Recommandation",
        per_premium: "Poids par lot premium",
        per_consolation: "Poids par consolation",
        lots: "lots",
        cumulative: "cumulé",
        expected: "Attendu",
        p_none: "P(0 lot ne tombe)",
        p_all: "P(tout distribuer)",
        over_allocated:
          "Trop de lots pour ce nombre de plays. Augmente les plays attendus ou réduis les lots.",
        apply_btn: "Appliquer les poids",
        apply_hint:
          "Les poids des lots premium seront uniformisés et le reste sera réparti sur les segments de consolation. Total garanti à 100 %.",
      },
      game_editor: {
        title: "Titre",
        description: "Description",
        export_pdf: "Fiche PDF",
        export_pdf_hint: "Télécharge la fiche technique PDF du jeu",
        game_type: "Type de jeu",
        language: "Langue du jeu",
        language_en: "Anglais",
        language_fr: "Français",
        segments: "Segments de la roue",
        prize_pool: "Lots à gagner",
        ctas: "Actions à réaliser",
        add_segment: "Ajouter un segment",
        add_cta: "Ajouter un CTA",
        label: "Libellé",
        color: "Couleur",
        winning: "Gagnant",
        weight: "Poids",
        chance: "% de chances",
        actual_chance: "réel",
        total_chance: "Total",
        normalize_sum: "Normaliser à 100 %",
        sum_ok: "Les probabilités totalisent 100 %",
        sum_warning: "Total : {{sum}} % — les valeurs seront normalisées au tirage.",
        initial_qty: "Quantité initiale",
        remaining_qty: "Quantité restante",
        unlimited: "Illimité",
        out_of_stock: "Épuisé",
        claim_days: "Jours pour réclamer",
        claim_deadline: "Date limite d'utilisation",
        coupon: "Coupon",
        redemption_url: "Adresse du site web",
        prize_details: "Détails du lot",
        segment_image: "Image du lot",
        segment_image_hint:
          "Optionnel — affichée dans le jeu (rouleaux, roue, cartes, boîte). PNG détouré (fond transparent) conseillé.",
        segment_image_add: "Ajouter une image",
        segment_image_replace: "Remplacer",
        type: "Type",
        url: "URL",
        url_hint: "L'URL web. Sur mobile, un deeplink vers l'app native est utilisé automatiquement si disponible (Instagram, Facebook, TikTok, YouTube, LinkedIn, Tripadvisor).",
        ios_url: "URL App Store (iOS)",
        android_url: "URL Google Play (Android)",
        cta_instruction: "Texte d'aide affiché sous l'action (optionnel)",
        cta_instruction_hint: "Laissez vide pour garder le texte par défaut de ce type d'action.",
        confirm_hint: "Écran de confirmation après l'inscription au tirage (tirage au sort / sans-faute au quiz). Laissez vide pour garder les textes par défaut.",
        confirm_title: "Titre de confirmation",
        confirm_body: "Texte de confirmation",
        quiz_intro_hint: "Carte d'accueil du quiz (avant la première question). Laissez vide pour garder les textes par défaut.",
        quiz_intro_text: "Texte d'accueil",
        quiz_winners_label: "Badge gagnants (ex. « 1 gagnant tiré au sort le 14 novembre »)",
        test_link_title: "Lien de test annonceur",
        test_link_hint: "Fonctionne avant la date de début, après la fin et quand le jeu est en pause ; rejouable à volonté. Les participations test sont rangées à part : jamais dans les participants, les stats ou les tirages, les stocks de lots ne bougent pas et les emails portent le préfixe [TEST]. Ne le diffusez jamais publiquement.",
        test_link_copy: "Copier",
        test_link_open: "Tester",
        test_link_copy_error: "Impossible de copier le lien",
        app_urls_hint: "Les visiteurs iOS sont redirigés vers l'App Store, les Android vers Google Play. L'URL de repli ci-dessus est utilisée sur desktop ou si un store manque.",
        required: "Requis",
        win_message: "Message de victoire",
        lose_message: "Message de défaite",
        theme_color: "Couleur thème",
        rules_url: "Lien du règlement",
        rules_url_hint: "URL optionnelle vers les conditions du jeu",
        save: "Enregistrer",
        saved: "Enregistré",
        duplicate: "Dupliquer",
        duplicate_hint: "Crée une copie désactivée de ce jeu",
        duplicate_confirm:
          "Dupliquer ce jeu ? Le nouveau jeu sera créé désactivé, prêt à être ajusté.",
        duplicated: "Jeu dupliqué — édition de la nouvelle copie",
        assign: "Assigné à",
        none: "— non assigné —",
        active: "Actif",
        public_link: "Lien public du jeu",
        merchant_qr_link: "Lien du QR code enseigne (permanent)",
        merchant_qr_hint:
          "Imprimé une seule fois, valable à vie. Le QR redirige automatiquement vers le jeu actif de cette enseigne.",
        sibling_warning_title: "Un autre jeu est actif sur cette enseigne",
        sibling_warning_body:
          "Le QR code permanent de l'enseigne pointe vers le jeu actif le plus récemment créé. Désactivez les autres jeux si vous souhaitez que celui-ci prenne le relais.",
        start_date: "Date de début",
        end_date: "Date de fin",
        start_time: "Heure d'ouverture",
        end_time: "Heure de fermeture",
        computed_status: "Statut actuel",
        date_hint:
          "Heures en GMT+4 (La Réunion). Sans heure de fermeture, le jeu se termine à 00:00 GMT+4 le jour de fin (exclu). Laissez vide pour ne pas contraindre.",
        winners_count: "Nombre de gagnants",
        winners_count_hint:
          "Nombre de participants tirés au sort lorsque vous déclenchez le tirage.",
        pred_sport: "Sport",
        pred_sport_hint: "Définit les équipes disponibles et le format du score",
        pred_teams_title: "Bibliothèque d'équipes",
        pred_teams_hint: "Les équipes sont partagées entre tous les jeux pronostic de ce sport",
        pred_team_add: "Ajouter une équipe",
        pred_team_name: "Nom de l'équipe",
        pred_team_logo: "Logo",
        pred_team_logo_upload: "Téléverser le logo",
        pred_team_delete: "Supprimer",
        pred_matches_title: "Matchs",
        pred_match_add: "Ajouter un match",
        pred_match_team_a: "Équipe A (domicile)",
        pred_match_team_b: "Équipe B (extérieur)",
        pred_match_datetime: "Date & heure du coup d'envoi (GMT+4)",
        pred_end_before_match: "La date de fin doit être avant le premier coup d'envoi",
        pred_match_result: "Score final",
        pred_match_score_a: "Score A",
        pred_match_score_b: "Score B",
        pred_match_winner: "Vainqueur",
        pred_match_winner_a: "Équipe A gagne",
        pred_match_winner_b: "Équipe B gagne",
        pred_save_matches: "Enregistrer les matchs",
        pred_matches_saved: "Matchs enregistrés",
        pred_result_saved: "Résultat enregistré",
        pred_draw_btn: "Tirer les gagnants",
        pred_missing_results: "Veuillez d'abord saisir tous les scores finaux",
        pred_reward_mode: "Mode de récompense",
        pred_reward_mode_hint:
          "Tirage = gagnants tirés au sort parmi les bons pronostics. 100% gagnant = tous les bons pronostiqueurs gagnent le lot garanti.",
        pred_reward_draw: "Tirage au sort",
        pred_reward_all: "100% gagnant",
        pred_prize_label: "Lot garanti *",
        pred_prize_label_ph: "Ex : Un dessert offert",
        pred_coupon_code: "Code promo (optionnel)",
        pred_coupon_code_hint:
          "Laissez vide pour générer un code unique par gagnant.",
        pred_claim_days: "Validité (jours)",
        pred_claim_days_hint:
          "Durée pendant laquelle les gagnants peuvent récupérer leur lot après la distribution.",
        pred_claim_deadline: "Date limite de récupération (optionnel)",
        pred_claim_deadline_hint:
          "Si renseignée, remplace la validité en jours. Affichée dans l'email du gagnant (« Expire le »).",
        pred_prize_instructions: "Instructions du lot (email)",
        pred_prize_instructions_ph: "Ex : Présentez cet email au comptoir.",
        pred_prize_required: "Renseignez d'abord le nom du lot garanti",
        pred_distribute_btn: "Distribuer les lots",
        gp_real_price: "Prix réel (€)",
        gp_real_price_hint: "Secret — jamais affiché aux joueurs",
        gp_image: "Image du produit / vitrine",
        gp_image_hint: "Affichez un produit unique ou une vitrine avec plusieurs articles",
        gp_draw_btn: "Tirer les gagnants",
        quiz_title: "Questions du quiz",
        quiz_hint:
          "Le participant ne voit que les questions. Tous ceux qui répondent juste à TOUTES les questions participent automatiquement au tirage au sort. Mauvaise réponse → score affiché + une dernière tentative avec les mêmes infos.",
        quiz_winners_hint: "Gagnants tirés au sort parmi les participants ayant fait un sans-faute.",
        quiz_time: "Temps par question",
        quiz_time_none: "Sans limite de temps",
        quiz_time_seconds: "{{seconds}} secondes",
        quiz_time_hint: "Temps écoulé → le quiz passe automatiquement à la question suivante.",
        quiz_question_n: "Question {{n}}",
        quiz_question_ph: "Saisissez votre question…",
        quiz_multiple: "Plusieurs bonnes réponses",
        quiz_multiple_hint: "Le participant coche plusieurs cases au lieu d'un choix unique.",
        quiz_show_expected: "Indiquer le nombre de réponses attendues",
        quiz_show_expected_hint: "Ex. « 2 réponses attendues » sur les questions à plusieurs bonnes réponses.",
        quiz_unlimited: "Participation illimitée",
        quiz_unlimited_hint: "Les joueurs peuvent rejouer et retenter sans limite. Une seule chance chacun au tirage (1 par email).",
        quiz_answers_label: "Réponses — cochez la ou les bonnes réponses",
        quiz_mark_correct: "Marquer comme bonne réponse",
        quiz_answer_ph: "Réponse {{n}}",
        quiz_add_answer: "Ajouter une réponse",
        quiz_link_toggle: "Lien d'aide (ex. catalogue, fiche produit)",
        quiz_link_label_ph: "Texte du lien, ex. « Consulter le catalogue »",
        quiz_question_invalid: "Il faut un intitulé, au moins 2 réponses et au moins 1 bonne réponse.",
        quiz_no_questions: "Aucune question — ajoutez votre première question ci-dessous.",
        quiz_add_question: "Ajouter une question",
        quiz_retry_message: "Message après un 1ᵉʳ échec",
        quiz_retry_message_hint: "Affiché avec les questions ratées et le bouton « Retenter ma chance ». Le « Message perdant » (section Textes) sert à la pop-up après le 2ᵉ échec.",
        usable_from: "Coupon utilisable dès",
        usable_from_hint:
          "Le code envoyé par email ne pourra être utilisé qu'à partir de ce moment.",
        usable_immediately: "Immédiatement",
        usable_tomorrow: "Demain",
        usable_next_monday: "Lundi prochain",
        usable_custom: "Date personnalisée…",
        promo_mode_badge: "Mode code promo en ligne",
        promo_description: "Description dans l'email (optionnelle)",
        promo_description_placeholder:
          "La remise des 10% peut être utilisée sur notre site internet ou sur nos stands (RUN MARKET DUPARC Sainte Marie ou CARREFOUR Sainte Suzanne)…",
        promo_description_hint:
          "Ce texte s'affichera dans l'email sous le code coupon. Utilisez-le pour expliquer où/comment utiliser le code.",
        ninja_duration: "Durée",
        ninja_winners_hint: "Les N meilleurs scores gagnent (1er, 2e, 3e…)",
        ninja_points: "Points / produit",
        ninja_points_hint:
          "Points de base par produit tranché (combo max x3)",
        ninja_blade_color: "Couleur de la lame",
        ninja_product_images: "Images des produits",
        ninja_product_images_hint:
          "Uploadez des photos de vos produits — ils deviendront les projectiles. Si vide, des fruits par défaut sont utilisés.",
        ninja_upload_product: "Ajouter une image de produit",
        ninja_load_demo: "Charger des produits de démo",
        ninja_bomb_image: "Image de la bombe",
        ninja_bomb_image_hint:
          "Toucher la bombe termine la partie instantanément. Par défaut : emoji bombe.",
        ninja_upload_bomb: "Uploader l'image de bombe",
        ninja_total_participants: "Parties jouées",
        ninja_best_score: "Meilleur score",
        ninja_winners_drawn: "Gagnants tirés",
        ninja_draw_btn: "Tirer les gagnants",
        card_back_color: "Couleur du dos des cartes",
        card_back_color_hint:
          "Couleur de fond des cartes (Duel de cartes). Le logo de l'enseigne apparaît en filigrane par-dessus.",
        scratch_color: "Couleur du film à gratter",
        scratch_color_hint:
          "Couleur du film à gratter. Le logo de l'enseigne apparaît en filigrane par-dessus.",
        wheel_label_orientation: "Orientation du texte sur la roue",
        wheel_design: "Design de la roue",
        wheel_design_hint: "Choisissez l'apparence de la roue pour ce jeu. Vous pouvez revenir à l'autre design à tout moment.",
        wheel_design_classic: "Design actuel",
        wheel_design_premium: "Nouveau design",
        wheel_rim_color: "Couleur du contour",
        wheel_curved_text: "Texte courbé sous la roue",
        wheel_curved_text_default: "Et plein d'autres cadeaux",
        wheel_button_label: "Texte du bouton",
        wheel_themes: "Thèmes — un clic applique les couleurs de la roue et des boutons (retouchables ensuite)",
        wheel_theme_applied: "Thème « {{name}} » appliqué — pensez à enregistrer",
        wheel_theme_fastfood: "Fast-food",
        wheel_theme_noel: "Noël",
        wheel_theme_valentin: "Saint-Valentin",
        wheel_theme_halloween: "Halloween",
        wheel_theme_luxe: "Luxe",
        wheel_show_prize_names: "Afficher le nom des lots",
        wheel_show_prize_names_hint: "Désactivé : les segments gagnants affichent la photo du lot, ou une icône cadeau par défaut. Les segments perdants gardent leur texte (ex. « PERDU », modifiable dans la liste des lots).",
        wheel_premium_segments_hint: "Les couleurs et textes des segments se règlent dans la liste des lots. Les segments gagnants affichent une icône cadeau (ou la photo du lot) au-dessus de leur texte.",
        wheel_label_orientation_hint:
          "Passez en vertical si les noms de vos lots sont trop longs pour tenir horizontalement dans une part. Le texte vertical s'écrit dans le sens du rayon (du centre vers le bord) et accepte jusqu'à 22 caractères.",
        wheel_label_horizontal: "Horizontal (par défaut)",
        wheel_label_vertical: "Vertical (radial)",
        wheel_label_preview_caption:
          "L'aperçu en temps réel utilise vos vrais lots. Les libellés horizontaux longs passent automatiquement sur 2 lignes.",
        text_colors: "Couleurs du titre et de la description",
        text_colors_hint:
          "Personnalisez la couleur du texte affiché sur la page de jeu publique. Utile lorsque votre image de fond rend le titre ou la description peu lisibles. Laissez vide pour utiliser la couleur du thème (s'adapte automatiquement au mode clair/sombre).",
        title_color: "Couleur du titre",
        description_color: "Couleur de la description",
        color_reset: "Réinitialiser par défaut",
        color_using_default: "Couleur du thème utilisée",
        fonts_section: "Typographie",
        fonts_hint:
          "Choisissez une police pour chaque élément de la page de jeu publique. Laissez « Par défaut » pour conserver la police du thème.",
        font_title: "Titre",
        font_description: "Description",
        font_prizes: "Libellés des lots",
        font_messages: "Messages gagné / perdu",
        font_buttons: "Boutons",
        font_cta: "Actions (CTA)",
        font_default: "Par défaut (thème)",
        advent_title: "Calendrier de l'Avent — Configuration",
        advent_mode: "Mode de jeu",
        advent_mode_daily: "Quotidien — une case par jour",
        advent_mode_free: "Libre — une seule case au choix",
        advent_days: "Nombre de cases",
        advent_start: "Date de la case n°1",
        advent_catchup: "Rattrapage des cases manquées",
        advent_catchup_hint: "Si activé, un joueur peut ouvrir les cases des jours passés. Sinon, une case manquée est perdue.",
        advent_doors: "Les cases — lot, probabilité de gain et stock",
        advent_col_day: "Case",
        advent_col_prize: "Lot (vide = case perdante)",
        advent_col_prob: "% de gain",
        advent_col_stock: "Stock",
        advent_prize_ph: "Ex : Café offert",
        advent_reminder: "Rappel quotidien par email",
        advent_reminder_hint: "Chaque matin (8h, heure de La Réunion), les participants qui n'ont pas encore ouvert la case du jour reçoivent « Votre case du jour vous attend 🎁 ».",
        advent_doors_hint: "Chaque case a son lot et sa probabilité. Une case sans lot est toujours perdante. Le stock limite le nombre de gains (vide = illimité).",
        advent_ambience_title: "Ambiance & décor",
        advent_theme_snow: "Neige / Noël",
        advent_theme_stars: "Nuit étoilée",
        advent_theme_autumn: "Automne",
        advent_theme_spring: "Printemps / Pâques",
        advent_theme_summer: "Été / Tropical",
        advent_theme_valentine: "Saint-Valentin",
        advent_theme_ramadan: "Ramadan / Nuit dorée",
        advent_theme_birthday: "Anniversaire / Marque",
        advent_theme_none: "Aucun effet",
        advent_intensity: "Intensité des particules",
        advent_intensity_light: "Léger",
        advent_intensity_normal: "Normal",
        advent_intensity_festive: "Festif",
        advent_bg_color: "Couleur de fond",
        advent_bg_preview: "Fond",
        advent_bg_hint: "Sans couleur personnalisée, le décor du thème est utilisé (le thème Anniversaire reprend la couleur principale du jeu). Une couleur claire est automatiquement assombrie pour garder le texte lisible.",
        advent_sound: "Ambiance sonore",
        advent_sound_music_sfx: "Musique + son d'ouverture",
        advent_sound_sfx: "Son d'ouverture uniquement",
        advent_sound_off: "Silence",
        advent_music_play: "Écouter",
        advent_music_stop: "Arrêter",
        advent_sfx_play: "Son d'ouverture",
        advent_sound_hint: "Musique et sons sont générés par le navigateur (aucun fichier à charger). Le joueur peut couper le son à tout moment via le haut-parleur affiché sur le calendrier.",
        font_weight_auto: "Graisse auto",
        font_using_default: "Police du thème utilisée",
        appearance_section: "Boutons & effets",
        appearance_hint:
          "Personnalisez les boutons, l'assombrissement du fond, le mode d'affichage et les effets de victoire de la page de jeu publique.",
        button_bg: "Fond des boutons",
        button_text: "Texte des boutons",
        button_radius: "Forme des boutons",
        radius_default: "Par défaut (arrondi)",
        radius_pill: "Pilule",
        radius_square: "Carré",
        continue_label: "Texte du bouton « Continuer »",
        ready_label: "Texte du bouton « Prêt à jouer »",
        overlay_label: "Assombrissement du fond",
        overlay_hint:
          "Voile sombre sur l'image de fond pour la lisibilité. 55 % par défaut.",
        theme_label: "Mode d'affichage",
        theme_auto: "Auto (choix du joueur)",
        theme_light: "Clair forcé",
        theme_dark: "Sombre forcé",
        confetti_label: "Couleurs des confettis de victoire",
        confetti_enable: "Personnaliser les confettis",
        hub_logo_label: "Logo de l'enseigne au centre de la roue",
        hub_logo_hint: "Remplace le texte SPIN par le logo de l'enseigne.",
        size_sm: "Petite",
        size_md: "Normale",
        size_lg: "Grande",
        size_xl: "Très grande",
        win_image_label: "Image / GIF de victoire",
        og_image_label: "Image de partage (réseaux)",
        sounds_label: "Sons du jeu",
        sounds_hint:
          "Tic-tac de la roue + jingle de victoire. Le joueur peut couper le son.",
        form_section: "Formulaire joueur",
        phone_field: "Champ téléphone",
        phone_required: "Obligatoire",
        phone_optional: "Facultatif",
        phone_hidden: "Masqué",
        birthdate_label: "Demander la date de naissance",
        children_field: "Champ nombre d'enfants",
        city_field: "Champ ville",
        button_bg_2: "Dégradé — 2ᵉ couleur",
        quiz_select_color: "Réponse sélectionnée (quiz)",
        quiz_select_color_preview: "✓ Réponse choisie",
        advent_door_image: "Image de la case (facultative)",
        advent_door_image_hint: "L'image (facultative, carrée de préférence) apparaît au dos de la case quand elle s'ouvre.",
        button_bg_2_hint: "Aperçu du dégradé",
        purchase_proof_title: "Ticket de caisse obligatoire",
        daily_prize_title: "Gagnants par jour",
        daily_prize_hint: "Nombre limité de gagnants par jour, tous joueurs confondus : une fois atteint, les joueurs suivants perdent jusqu'à minuit (heure de La Réunion). Les lots non gagnés ne se reportent pas. Chaque participant peut jouer une fois par jour.",
        daily_win_limit: "Nombre de gagnants par jour",
        purchase_proof_hint:
          "Si activé, le participant devra importer ou prendre en photo son ticket de caisse avant de pouvoir jouer. L'OCR par IA extrait automatiquement le montant, la date et le nom du commerce pour contrôle.",
        purchase_filters: "Validation automatique (optionnelle)",
        purchase_min_amount: "Montant minimum du ticket",
        purchase_min_amount_placeholder: "ex. 15 €",
        purchase_max_days: "Ancienneté max (jours)",
        purchase_max_days_placeholder: "ex. 7 jours",
        purchase_merchant_keyword: "Nom du commerce doit contenir",
        purchase_merchant_keyword_placeholder: "ex. DEALRUN",
        purchase_filters_hint:
          "Laissez vide pour désactiver un filtre. Un ticket non conforme est refusé avec un message clair ; la photo reste visible au marchand dans la liste des participants.",
        shipping_address_title: "Collecter l'adresse postale",
        shipping_address_hint:
          "Si activé, le participant devra renseigner une adresse postale (rue, code postal, ville, complément optionnel) avant de finaliser. À utiliser pour les campagnes où vous expédiez un cadeau physique (stickers, mugs, t-shirts).",
      },
      errors: {
        generic: "Une erreur est survenue. Réessayez dans un instant.",
        invalid_input: "Certaines informations sont invalides. Vérifiez le formulaire.",
        already_participated: "Vous avez déjà participé à ce jeu-concours. Un seul essai par personne et par téléphone est autorisé.",
        already_played_today: "Vous avez déjà joué aujourd'hui. Revenez demain pour retenter votre chance !",
        daily_prize_needs_losing: "Ajoutez au moins un segment perdant (ex. « Retente ta chance ») pour utiliser « Un lot par jour ».",
        device_identity_mismatch: "Pour éviter toute fraude, vous ne pouvez pas jouer avec d'autres informations sur ce téléphone. Utilisez les mêmes informations qu'à votre première participation, ou changez de téléphone.",
        receipt_required: "Une preuve d'achat est requise pour participer à ce jeu.",
        receipt_amount_too_low: "Le ticket ne remplit pas le montant minimum requis ({{min_amount}} €).",
        receipt_too_old: "Le ticket doit dater de moins de {{max_days}} jours.",
        receipt_merchant_mismatch: "Ce ticket ne semble pas provenir de «{{expected_keyword}}».",
        receipt_already_used: "Ce ticket de caisse a déjà été utilisé pour participer à un jeu.",
        shipping_address_required: "L'adresse postale (rue, code postal, ville) est obligatoire pour finaliser votre inscription.",
        advent_not_configured: "Le calendrier n'a pas encore de date de départ.",
        advent_not_started: "Le calendrier n'a pas encore commencé. Revenez bientôt !",
        door_locked: "Cette case n'est pas encore déverrouillée. Revenez le jour J !",
        door_missed: "Cette case est passée — le rattrapage n'est pas autorisé sur ce calendrier.",
        door_already_opened: "Vous avez déjà ouvert cette case. Revenez demain pour la suivante !",
        no_attempts_left: "Vous avez déjà utilisé vos deux tentatives.",
        invalid_code_format: "Le code doit contenir 6 chiffres.",
        code_not_found: "Ce code ne correspond à aucune participation. Vérifie l'orthographe ou retape-le depuis ton email.",
        game_not_open: "Le jeu n'est pas ouvert en ce moment.",
        game_not_found: "Ce jeu est introuvable ou n'est plus disponible.",
        ctas_missing: "Merci de terminer toutes les étapes demandées avant de jouer.",
        phone_required: "Le numéro de téléphone est obligatoire.",
        city_required: "La ville est obligatoire.",
        children_required: "Le nombre d'enfants est obligatoire.",
        name_required: "Le nom est obligatoire.",
        predictions_closed: "Les pronostics sont fermés : un match a déjà commencé.",
        pred_missing: "Merci de pronostiquer tous les matchs.",
        quiz_incomplete: "Merci de répondre à toutes les questions.",
        session_not_found: "Votre partie est introuvable. Rechargez la page et réessayez.",
        score_rejected: "Score refusé. Rejouez une partie normalement.",
        claim_not_found: "Ce lien de coupon est invalide ou a expiré.",
        score_not_counted: "Score non comptabilisé",
      },
      flappy: {
        timeout: "Délai réseau dépassé",
        hud_score: "Score",
        intro_eyebrow: "Mini-jeu",
        intro_title: "Fais voler la mascotte !",
        intro_sub: "Tape sur l'écran pour battre des ailes et passe entre les obstacles. Plus ton score est haut, mieux c'est !",
        intro_btn: "Jouer maintenant",
        submitting: "Calcul du score…",
        result_eyebrow: "Score final",
        rank: "Tu es {{rank}}e sur {{total}}",
        rank_in_top: "Tu es actuellement dans le top {{n}} ! On t'envoie un email si tu es toujours gagnant à la fin du concours.",
        rank_out_top: "Les {{n}} meilleurs scores gagnent. Continue à jouer… ah non, une seule participation par personne 😄 Croisons les doigts !",
        tournament_ends: "Fin du concours : {{date}}",
        result_win: "Tu as gagné !",
        result_reveal: "Voir mon cadeau",
        result_lose: "Pas de lot cette fois",
        result_lose_sub: "Il fallait atteindre le palier minimum. Reviens une prochaine fois !",
      },
      mystery: {
        already: "Vous avez déjà participé à ce jeu",
        back_to_email: "Retour",
        claim_btn: "Voir mon cadeau",
        code_format: "Le code doit contenir 6 chiffres.",
        code_invalid: "Code invalide",
        editor_email_intro: "Texte d'introduction de l'email (optionnel)",
        editor_email_intro_hint: "Si laissé vide, un texte par défaut est utilisé. Maximum 500 caractères.",
        editor_email_intro_placeholder: "Tu as participé au tirage spécial Saint-Valentin chez Bistro Lumière. Voici ton code pour ouvrir ta boîte mystère…",
        editor_email_subject: "Objet de l'email du code (optionnel)",
        editor_email_subject_placeholder: "🎁 Ton code pour ouvrir la boîte chez Bistro Lumière",
        editor_style: "Style de la boîte",
        editor_style_hint: "Le style choisi est affiché aux joueurs sur la page publique et dans l'animation d'ouverture.",
        editor_title: "Configuration Boîte mystère",
        enter_manually: "Saisir le code manuellement",
        eyebrow: "Boîte mystère",
        fallback_text: "Nous n'avons pas pu envoyer l'email à {{email}}, mais voici quand même ton code. Note-le, tu en auras besoin pour rouvrir la boîte.",
        fallback_title: "Voici ton code",
        intro_text: "Participe maintenant pour recevoir ton code à 6 chiffres par email. Avec ce code, tu pourras tenter d'ouvrir la boîte et découvrir si elle te réserve un cadeau.",
        intro_title: "Qu'y a-t-il dans la boîte ?",
        lose_eyebrow: "Boîte vide",
        lose_text: "Le code ne correspond à aucun lot dans cette boîte. Tente ta chance lors d'un prochain jeu !",
        participate: "Recevoir mon code par email",
        replay: "Tu as déjà ouvert cette boîte",
        sending: "Envoi du code…",
        sent_spam_hint: "Pense à vérifier le dossier spam si tu ne le vois pas.",
        sent_text: "Nous avons envoyé un email contenant ton code à 6 chiffres à {{email}}. Clique sur le bouton dans l'email pour ouvrir ta boîte.",
        sent_title: "Vérifie ta boîte mail !",
        submit_error: "Impossible d'envoyer le code par email",
        unlock_btn: "Ouvrir ma boîte",
        unlocking: "Ouverture de la boîte…",
        win_eyebrow: "Tu as gagné",
        your_code: "Ton code à 6 chiffres",
        your_address: "ton adresse",
      },
      claim: {
        badge: "QRISE · Votre gain",
        bravo_name: "Bravo {{name}}",
        bravo: "Bravo",
        title: "Vous avez gagné !",
        at: "chez",
        default_prize: "Votre lot",
        code_label: "Code à présenter en caisse",
        show_screen: "Montrez cet écran à l'accueil pour récupérer votre lot.",
        redeemed_pill: "Lot validé · enregistré auprès du marchand",
        game_by: "Game by QRISE",
        already_eyebrow: "Déjà récupéré",
        already_title: "Lot déjà récupéré",
        already_body_1: "Vous avez déjà récupéré votre lot pour ce concours.",
        already_body_2: "Merci de votre participation !",
        collected_on: "Récupéré le {{date}}",
        soon_title: "Bientôt disponible",
        soon_body_1: "Votre lot sera récupérable <strong>{{when}}</strong>.",
        soon_body_2: "Revenez à ce moment-là et cliquez à nouveau sur le lien reçu par email.",
        when_next_monday: "lundi prochain",
        when_tomorrow: "demain",
        when_date: "le {{date}}",
        when_soon: "bientôt",
        expired_title: "Code expiré",
        expired_body: "Désolé, la période de récupération de ce lot est terminée.",
        expired_contact: "Contactez <strong>{{merchant}}</strong> si vous pensez qu'il s'agit d'une erreur.",
        invalid_title: "Lien invalide",
        receipt: "Ticket de caisse",
      },
      play: {
        page_badge: "Jeu QRISE",
        grand_draw_kicker: "Grand tirage final",
        grand_draw_banner_all_one:
          "En jouant, vous participez automatiquement au grand tirage au sort final — 1 gagnant à la fin de la campagne !",
        grand_draw_banner_all_other:
          "En jouant, vous participez automatiquement au grand tirage au sort final — {{count}} gagnants à la fin de la campagne !",
        grand_draw_banner_losers_one:
          "Seconde chance : tous les joueurs qui n'ont pas gagné participent automatiquement au grand tirage final — 1 gagnant !",
        grand_draw_banner_losers_other:
          "Seconde chance : tous les joueurs qui n'ont pas gagné participent automatiquement au grand tirage final — {{count}} gagnants !",
        grand_draw_result_win_one:
          "Bonus : vous êtes aussi automatiquement inscrit(e) au grand tirage au sort final — 1 gagnant désigné à la fin de la campagne. Surveillez votre boîte mail !",
        grand_draw_result_win_other:
          "Bonus : vous êtes aussi automatiquement inscrit(e) au grand tirage au sort final — {{count}} gagnants désignés à la fin de la campagne. Surveillez votre boîte mail !",
        grand_draw_result_lose_one:
          "Bonne nouvelle : vous êtes automatiquement inscrit(e) au grand tirage au sort final — 1 gagnant désigné à la fin de la campagne. Surveillez votre boîte mail !",
        grand_draw_result_lose_other:
          "Bonne nouvelle : vous êtes automatiquement inscrit(e) au grand tirage au sort final — {{count}} gagnants désignés à la fin de la campagne. Surveillez votre boîte mail !",
        your_info: "Entrez vos infos pour jouer",
        first_name: "Prénom",
        last_name: "Nom",
        email: "Email",
        phone: "Téléphone",
        optional_suffix: "facultatif",
        birthdate: "Date de naissance",
        children_count: "Nombre d'enfants",
        city: "Ville",
        address_line1: "Adresse",
        address_line2: "Complément d'adresse (optionnel)",
        postal_code: "Code postal",
        city: "Ville",
        shipping_section_title: "Adresse postale",
        shipping_section_hint: "",
        registration_gift_finish: "Finaliser mon inscription",
        registration_gift_done_kicker: "Inscription confirmée",
        registration_gift_done_title: "Merci, votre cadeau arrive !",
        registration_gift_done_body:
          "Nous avons enregistré vos informations et vous expédierons votre cadeau à l'adresse ci-dessous très prochainement.",
        registration_gift_address_recap: "Votre adresse d'expédition",
        registration_gift_email_notice:
          "Un email de confirmation avec le récapitulatif de votre adresse vient de vous être envoyé.",
        continue: "Continuer",
        gdpr_consent:
          "J'accepte de recevoir des communications marketing de {{merchant}} et j'autorise le partage de mes coordonnées (email, téléphone) à cette fin.",
        gdpr_hint:
          "Facultatif — vos données sont protégées. Vous pouvez participer sans cocher cette case ; dans ce cas, seuls vos prénom et nom seront visibles par le marchand. Une signature technique anonyme (IP + appareil) est conservée le temps du jeu pour éviter les participations multiples.",
        already_eyebrow: "Déjà participé",
        already_title: "Vous avez déjà joué à ce concours",
        already_title_today: "Vous avez déjà joué aujourd'hui",
        already_hint_today: "Une participation par personne et par jour. Revenez demain pour une nouvelle chance de gagner !",
        already_hint:
          "Une seule participation par personne et par téléphone est autorisée par concours. Un nouveau jeu-concours de ce marchand sera bientôt disponible — repassez plus tard !",
        already_game: "Jeu concerné",
        complete_actions: "Complétez ces actions",
        cta_banner_eyebrow: "Pour jouer",
        cta_banner_single: "Pour tenter votre chance, {{action}}.",
        cta_banner_double: "Pour tenter votre chance, {{action1}} et {{action2}}.",
        cta_banner_multi: "Pour tenter votre chance, complétez les {{count}} actions rapides ci-dessous.",
        cta_banner_hint:
          "Appuyez sur <b>Ouvrir</b> pour valider chaque étape, puis revenez ici et cliquez sur <b>Prêt à jouer ?</b>.",
        cta_banner_eyebrow_registration: "Pour vous inscrire",
        cta_banner_single_registration: "Pour recevoir votre cadeau, {{action}}.",
        cta_banner_double_registration: "Pour recevoir votre cadeau, {{action1}} et {{action2}}.",
        cta_banner_multi_registration: "Pour recevoir votre cadeau, complétez les {{count}} actions rapides ci-dessous.",
        cta_banner_hint_registration:
          "Appuyez sur <b>Ouvrir</b> pour valider chaque étape, puis revenez ici et cliquez sur <b>Finaliser mon inscription</b>.",
        cta_banner_action_facebook_like: "likez notre page <b>Facebook</b>",
        cta_banner_action_instagram_follow: "suivez <b>{{merchant}}</b> sur <b>Instagram</b>",
        cta_banner_action_tiktok_follow: "suivez <b>{{merchant}}</b> sur <b>TikTok</b>",
        cta_banner_action_youtube_subscribe: "abonnez-vous à notre chaîne <b>YouTube</b>",
        cta_banner_action_linkedin_follow: "suivez <b>{{merchant}}</b> sur <b>LinkedIn</b>",
        cta_banner_action_google_review: "laissez un avis et un commentaire sur <b>Google</b>",
        cta_banner_action_tripadvisor_review: "laissez un avis sur <b>Tripadvisor</b>",
        cta_banner_action_app_download: "téléchargez notre <b>application</b>",
        cta_banner_action_newsletter_signup: "inscrivez-vous à notre <b>newsletter</b>",
        cta_banner_action_account_creation: "créez un <b>compte</b> sur notre site",
        cta_banner_action_instagram_story: "partagez une <b>story sur Instagram</b>",
        cta_inst_facebook_like: "Liker notre page Facebook",
        cta_inst_instagram_follow: "Liker notre page Instagram",
        cta_inst_tiktok_follow: "Nous suivre sur TikTok",
        cta_inst_youtube_subscribe: "S'abonner à notre chaîne YouTube",
        cta_inst_linkedin_follow: "Suivre notre page LinkedIn",
        cta_inst_google_review: "Mettre un avis et un commentaire sur Google",
        cta_inst_tripadvisor_review: "Laisser un avis sur Tripadvisor",
        cta_inst_app_download: "Télécharger notre application",
        cta_inst_newsletter_signup: "S'inscrire à notre newsletter",
        cta_inst_account_creation: "Créer un compte sur notre site",
        cta_inst_instagram_story: "Partager une story sur Instagram",
        receipt_eyebrow: "Dernière étape",
        receipt_title: "Votre ticket de caisse",
        receipt_intro:
          "Pour valider votre participation, importez ou prenez en photo votre ticket de caisse.",
        receipt_take_photo: "Prendre une photo",
        receipt_pick_from_gallery: "Importer depuis la galerie",
        receipt_replace: "Remplacer la photo",
        receipt_uploading: "Upload en cours…",
        receipt_analyzing: "Analyse de votre ticket…",
        receipt_ready_title: "Ticket reçu",
        receipt_ready_desc:
          "Votre ticket a bien été transmis. Vous pouvez maintenant jouer.",
        receipt_ocr_amount: "Montant",
        receipt_ocr_date: "Date",
        receipt_ocr_merchant: "Commerce",
        receipt_privacy:
          "Votre ticket est conservé uniquement pour valider votre participation — visible uniquement par {{merchant}}.",
        receipt_error_network:
          "Impossible d'envoyer votre ticket. Vérifiez votre connexion et réessayez.",
        receipt_error_type:
          "Format de fichier non supporté. Utilisez une photo JPG, PNG ou HEIC.",
        receipt_error_size: "Fichier trop volumineux (8 Mo maximum).",
        receipt_continue: "Valider et jouer",
        receipt_back: "Retour",
        receipt_required_badge: "Obligatoire pour ce jeu",
        receipt_amount_too_low:
          "Ce ticket ne remplit pas le montant minimum requis ({{min}} €).",
        receipt_too_old: "Votre ticket doit dater de moins de {{days}} jours.",
        receipt_merchant_mismatch:
          "Ce ticket ne semble pas provenir de « {{keyword}} ».",
        receipt_required: "Une preuve d'achat est requise pour jouer.",
        rappel_eyebrow: "Petit rappel",
        rappel_title: "Petit rappel",
        legal_notice: "Mentions légales",
        copy_error: "Copie impossible — notez le code manuellement.",
        popup_info_title: "Détails supplémentaires",
        legal_privacy: "Confidentialité",
        legal_run_contest: "Organiser mon concours",
        pred_matches_count_one: "{{count}} match",
        pred_matches_count_other: "{{count}} matchs",
        rappel_continue: "C'est parti !",
        rappel_dont_show_again: "Ne plus afficher sur ce téléphone",
        rappel_step1_fallback: "Je complète l'action demandée",
        rappel_step1_facebook_like: "Je <b>follow</b> la page Facebook",
        rappel_step1_instagram_follow: "Je suis <b>{{merchant}}</b> sur <b>Instagram</b>",
        rappel_step1_tiktok_follow: "Je suis <b>{{merchant}}</b> sur <b>TikTok</b>",
        rappel_step1_youtube_subscribe: "Je m'<b>abonne</b> à la chaîne YouTube",
        rappel_step1_linkedin_follow: "Je suis <b>{{merchant}}</b> sur <b>LinkedIn</b>",
        rappel_step1_google_review: "Je laisse un <b>avis et un commentaire</b> sur Google",
        rappel_step1_tripadvisor_review: "Je laisse un <b>avis</b> sur Tripadvisor",
        rappel_step1_app_download: "Je <b>télécharge</b> l'application",
        rappel_step1_newsletter_signup: "Je m'inscris à la <b>newsletter</b>",
        rappel_step1_account_creation: "Je crée un <b>compte</b> sur le site",
        rappel_step1_instagram_story: "Je partage une <b>story Instagram</b>",
        rappel_step2:
          "Je reviens sur la page précédente ou sur l'onglet du concours",
        rappel_step2_hint_back: "Bouton retour",
        rappel_step2_hint_tabs: "Onglets / switcher",
        rappel_step3_instant: "Je lance le jeu et tente ma chance",
        rappel_step3_draw: "Je surveille le résultat du tirage au sort",
        verifying: "Vérification…",
        verified: "Vérifié",
        wheel_play_button: "Je joue",
        progress_restored: "Bon retour ! Votre progression a été retrouvée.",
        open_link: "Ouvrir",
        ready: "Prêt à jouer ?",
        spin: "TOURNER",
        spinning: "Ça tourne…",
        you_won: "Gagné !",
        you_lost: "Pas cette fois",
        play_again: "Rejouer",
        win_email_coupon:
          "Vous allez recevoir votre coupon par email pour récupérer votre cadeau.",
        win_thanks: "Merci d'avoir participé !",
        win_spam_warning:
          "Attention, il se peut que l'email tombe dans les spams.",
        powered: "Propulsé par QRISE",
        rules_link: "Voir le règlement du jeu",
        rules_download_pdf: "Télécharger le règlement (PDF)",
        your_code: "Votre code",
        copy: "Copier",
        copied: "Copié",
        redeem_at: "À réclamer sur",
        valid_until: "Valable jusqu'au",
        valid_for_days: "Valable {{days}} jours",
        required_badge: "Requis",
        optional_badge: "Optionnel",
        scratch_tap_to_reveal: "Tapez pour jouer",
        scratch_headline: "Grattez la carte",
        scratch_start: "Commencer",
        scratch_loading: "Préparation…",
        scratch_here: "GRATTEZ ICI",
        scratch_ready: "Prêt à gratter ?",
        advent_daily_badge: "Une case par jour",
        advent_hero_kicker: "Le grand jour",
        advent_today_pip: "Aujourd'hui",
        advent_sound_on: "Activer le son",
        advent_sound_off: "Couper le son",
        advent_free_badge: "Une seule case au choix",
        advent_day: "Jour",
        advent_open_today: "Ouvrez la case du jour !",
        advent_come_back: "Case du jour ouverte ! Prochaine case dans",
        advent_next_in: "Prochaine case dans",
        advent_pick_one: "Choisissez votre case porte-bonheur — une seule !",
        advent_free_done: "Votre case est ouverte — bonne chance pour la prochaine opération !",
        advent_open_any: "Ouvrez votre case !",
        advent_already_opened: "Vous avez déjà ouvert cette case.",
        advent_all_opened_kicker: "Calendrier terminé",
        advent_all_opened: "Toutes les cases sont ouvertes ! Merci d'avoir joué avec nous.",
        advent_all_opened_wins_one: "Vous avez remporté 1 lot — retrouvez-le dans vos emails.",
        advent_all_opened_wins_other: "Vous avez remporté {{count}} lots — retrouvez-les dans vos emails.",
        advent_all_opened_nowin: "Pas de lot cette fois-ci — à très bientôt pour une nouvelle opération !",
        advent_error: "Impossible d'ouvrir cette case pour le moment.",
        scratch_revealing: "Révélation…",
        scratch_hint:
          "Faites glisser votre doigt sur la surface pour révéler votre lot.",
        scratch_prize: "VOTRE LOT",
        scratch_outcome: "RÉSULTAT",
        penalty_aim: "Visez · Tirez",
        penalty_shot: "TIR EN COURS",
        penalty_goal: "BUUUT !",
        penalty_save: "ARRÊTÉ",
        penalty_hint: "Choisissez votre zone — le gardien va plonger !",
        penalty_shot_counter: "Tir {{n}}/{{total}}",
        penalty_combo: "Combo x{{n}}",
        penalty_recap: "{{score}}/{{total}} buts · Meilleur combo x{{best}}",
        penalty_hint_series:
          "5 tirs — le gardien apprend vite, variez vos zones !",
        card_start: "Retourner les cartes",
        card_loading: "Distribution…",
        card_ready: "Retournez les 4 cartes",
        card_progress: "{{count}}/4 retournée(s)",
        card_pair_found: "Deux cartes identiques — gagné !",
        card_all_different: "Quatre cartes différentes — retentez",
        lottery_badge: "Tirage au sort",
        lottery_winners_label_one: "1 gagnant sera tiré au sort",
        lottery_winners_label_other: "{{count}} gagnants seront tirés au sort",
        lottery_participate_cta: "Cliquez ici pour participer",
        lottery_submitting: "Validation…",
        lottery_entered: "Votre participation est enregistrée !",
        lottery_already_entered: "Vous avez déjà participé à ce tirage.",
        lottery_already_entered_badge: "Participation déjà enregistrée",
        lottery_confirmed_badge: "Participation validée",
        lottery_confirmed_title: "Voilà, c'est terminé !",
        lottery_confirmed_body:
          "Surveillez vos emails, vous serez prévenu si vous avez gagné ! Augmentez vos chances d'être tiré au sort en partageant le jeu sur vos réseaux sociaux.",
        lottery_share_title: "Augmentez vos chances",
        lottery_share_body:
          "Chaque ami qui participe via votre lien vous offre un ticket supplémentaire pour le tirage.",
        lottery_share_button: "Partager",
        lottery_share_text:
          "Je viens de participer au tirage {{title}} — tentez votre chance !",
        lottery_share_opened:
          "Super ! Chaque nouvel ami participant = +1 ticket.",
        lottery_copy_error: "Impossible de copier",
        slot_badge: "Machine à sous",
        slot_start: "Tirez le levier",
        slot_loading: "Préchauffage…",
        slot_ready: "Prêt à lancer ?",
        slot_spinning_reels: "Rouleaux en action… {{count}}/3",
        slot_triple_match: "JACKPOT ! Triple {{label}} — vous gagnez !",
        slot_no_match: "Pas de combinaison cette fois — réessayez",
        pred_badge: "Pronostic",
        pred_title: "Pronostiquez les scores",
        pred_body:
          "Devinez le score exact de chaque match. Seuls les pronostics parfaits participent au tirage.",
        pred_submit: "Valider mes pronostics",
        pred_submitting: "Envoi…",
        pred_tennis_winner: "Qui gagne ?",
        pred_your_score: "Votre pronostic",
        pred_required: "Veuillez remplir tous les pronostics",
        pred_closed: "Pronostics clôturés — un match a déjà commencé.",
        pred_confirmed_title: "C'est enregistré !",
        pred_confirmed_body:
          "Les résultats seront vérifiés après le coup de sifflet final. Bonne chance !",
        pred_already: "Vous avez déjà soumis vos pronostics.",
        pred_match_kickoff: "Coup d'envoi",
        pred_sport_football: "Football",
        pred_sport_basketball: "Basketball",
        pred_sport_tennis: "Tennis",
        pred_vs: "vs",
        pred_score_hint: "Entrez un nombre entier",
        gp_badge: "Juste prix",
        gp_title: "Devinez le juste prix",
        gp_body:
          "Regardez bien l'article ci-dessous et entrez le prix que vous lui donneriez. Le plus proche du prix réel gagne !",
        gp_input_label: "Votre prix (€)",
        gp_submit: "Valider mon prix",
        gp_submitting: "Envoi…",
        gp_confirmed_title: "Votre prix est enregistré !",
        gp_confirmed_body:
          "Le gagnant sera annoncé à la fin du jeu — celui dont le prix est le plus proche du prix réel remporte la partie.",
        gp_already: "Vous avez déjà soumis votre prix.",
        gp_required: "Veuillez entrer un prix",
        quiz_badge: "Quiz",
        test_mode_banner: "MODE TEST annonceur — participations non comptabilisées, anti-fraude désactivé",
        waiting_opens_on: "Ouverture le {{date}}",
        waiting_countdown_label: "Temps restant avant l'ouverture",
        waiting_unit_days: "jours",
        waiting_unit_hours: "heures",
        waiting_unit_minutes: "min",
        waiting_unit_seconds: "sec",
        quiz_intro_title: "{{count}} questions à répondre",
        quiz_intro_body:
          "Répondez juste à toutes les questions pour participer automatiquement au tirage au sort. En cas d'erreur, vous aurez une dernière tentative.",
        quiz_intro_winners_one: "1 gagnant tiré au sort",
        quiz_intro_winners_other: "{{count}} gagnants tirés au sort",
        quiz_intro_timer: "{{seconds}} s par question",
        quiz_start: "Commencer le quiz",
        quiz_progress: "Question {{current}} / {{total}}",
        quiz_single_hint: "Une seule réponse",
        quiz_multiple_hint: "Plusieurs réponses possibles",
        quiz_expected_count_one: "1 réponse attendue",
        quiz_expected_count_other: "{{count}} réponses attendues",
        quiz_intro_body_unlimited:
          "Répondez juste à toutes les questions pour participer automatiquement au tirage au sort. En cas d'erreur, vous pouvez retenter votre chance autant de fois que vous le souhaitez.",
        quiz_fail_retry_body_unlimited: "Les questions ratées sont mises en évidence ci-dessous. Vous pouvez retenter autant de fois que vous le souhaitez — mêmes infos, pas besoin de remplir le formulaire.",
        quiz_retry_sub_unlimited: "Mêmes infos, sans formulaire",
        quiz_link_default: "En savoir plus",
        quiz_next: "Suivant",
        quiz_submit: "Valider mes réponses",
        quiz_timer_hint: "{{seconds}} s par question — le quiz passe à la suite quand le temps est écoulé.",
        quiz_checking: "Vérification de vos réponses…",
        quiz_perfect_kicker: "Sans-faute !",
        quiz_score: "{{score}} / {{total}} bonnes réponses",
        quiz_draw_entered: "Vous participez automatiquement au tirage au sort — {{count}} gagnant(s) seront tirés. Bonne chance !",
        quiz_confirmed_body_one:
          "Vous participez automatiquement au tirage au sort (1 gagnant). Vous serez contacté(e) par nos services si vous êtes tiré(e) au sort. Augmentez vos chances d'être tiré(e) au sort en partageant le jeu sur vos réseaux sociaux.",
        quiz_confirmed_body_other:
          "Vous participez automatiquement au tirage au sort ({{count}} gagnants). Vous serez contacté(e) par nos services si vous êtes tiré(e) au sort. Augmentez vos chances d'être tiré(e) au sort en partageant le jeu sur vos réseaux sociaux.",
        quiz_share_text: "Je viens de réussir le quiz {{title}} — tentez votre chance !",
        quiz_fail_kicker: "Pas tout à fait…",
        quiz_fail_retry_body: "Les questions ratées sont mises en évidence ci-dessous. Il vous reste une dernière tentative — mêmes infos, pas besoin de remplir le formulaire.",
        quiz_fail_final_body: "Merci d'avoir participé !",
        quiz_retry_btn: "Retenter ma chance",
        quiz_retry_sub: "Dernière tentative — mêmes infos, sans formulaire",
        quiz_no_attempts: "Vous avez utilisé vos deux tentatives. Merci pour votre participation !",
        quiz_lose_default: "Dommage… c'était votre dernière tentative. Merci d'avoir joué, à bientôt !",
        quiz_empty: "Ce quiz n'a pas encore de questions.",
        ninja_badge: "Ninja Slice",
        ninja_title: "Tranche les produits, évite les bombes !",
        ninja_subtitle:
          "Tu as {{duration}}s. +{{points}} pts par produit tranché. Les meilleurs scores gagnent.",
        ninja_avoid_bombs: "Évite les bombes",
        ninja_combo_hint: "Combos = bonus",
        ninja_start: "Commencer",
        ninja_points: "points",
        ninja_bomb_hit: "Bombe touchée !",
        ninja_time_up: "Temps écoulé",
        ninja_submitted: "Score enregistré !",
        ninja_already_played: "Vous avez déjà joué.",
        ninja_winners_hint:
          "Les {{count}} meilleurs scores gagnent. Tu seras contacté si tu es dans le top.",
        ninja_top3: "Top 3 en direct",
        ninja_no_scores: "Sois le premier à marquer !",
      },
      quiz_draw: {
        title: "Tirage au sort du quiz",
        subtitle_one: "1 gagnant tiré au sort parmi les participants ayant répondu juste à toutes les questions. Tirage unique et définitif.",
        subtitle_other: "{{count}} gagnants tirés au sort parmi les participants ayant répondu juste à toutes les questions. Tirage unique et définitif.",
        participants: "Participants",
        eligible: "Sans-faute",
        draw_btn: "Tirer au sort",
        confirm_btn: "Confirmer — tirage définitif",
        cancel: "Annuler",
        drawing: "Tirage…",
        drawn_at: "Tirage effectué le {{date}}",
        done_note: "Le tirage est définitif et ne peut pas être refait.",
        definitive_note: "Un seul tirage possible — il ne pourra pas être refait.",
        no_eligible: "Aucun sans-faute pour l'instant — personne à tirer au sort.",
        winners_title_one: "🏆 1 gagnant tiré au sort",
        winners_title_other: "🏆 {{count}} gagnants tirés au sort",
        attempts_one: "1 tentative",
        attempts_other: "{{count}} tentatives",
        tickets_total: "{{count}} tickets dans l'urne (bonus parrainage inclus)",
        winner_message_title: "Message au gagnant",
        winner_message_copy: "Copier",
        winner_message_copied: "Message copié",
        winner_message_hint: "Défini dans Textes → « Message dans l'email gagnant ». À transmettre au gagnant par email ou téléphone.",
      },
      draw_reveal: {
        countdown_eyebrow: "Tirage au sort",
        countdown_title: "Le sort va parler…",
        drawing: "Tirage…",
        in_the_urn_one: "1 ticket dans l'urne",
        in_the_urn_other: "{{count}} tickets dans l'urne",
        winners_eyebrow: "Félicitations",
        winners_title: "Et le gagnant est…",
        winners_title_plural: "Et les gagnants sont…",
        close: "Fermer",
      },
      blow: {
        intro_eyebrow: "Fais un vœu",
        intro_title: "Souffle les bougies !",
        intro_sub: "Éteins toutes les bougies avant la fin du chrono pour révéler ton cadeau.",
        mode_mic: "Souffle dans le micro",
        mode_tap: "Tape ou maintiens l'écran",
        badge_fun: "Fun",
        badge_silent: "Silence",
        mic_denied: "Micro refusé — passe en mode tape.",
        calibration_eyebrow: "Calibration",
        calibration_title: "Reste silencieux une seconde…",
        calibration_sub: "On écoute le bruit ambiant pour régler ton micro.",
        gauge_label: "Souffle",
        mic_hint: "Approche le téléphone et souffle — ou tape sur le gâteau",
        tap_hint: "Tape vite ou garde le doigt appuyé sur le gâteau",
        revealing: "Ton cadeau se dévoile…",
        timeout: "La brise est tombée — temps écoulé !",
        all_out: "Toutes éteintes !",
      },
      inapp: {
        title: "Ouvre cette page dans ton navigateur",
        subtitle:
          "Pour jouer à ce jeu, ouvre-le dans le navigateur de ton téléphone — rapide, simple et sans souci de redirection.",
        step1_a: "Clique sur",
        step1_b: "en haut à droite de l'écran",
        step2_a: "Puis choisis",
        step2_action: "Ouvrir dans le navigateur",
        why_label: "Pourquoi ?",
        why_body:
          "Les navigateurs intégrés (Instagram, Facebook, TikTok…) bloquent parfois les redirections et les connexions. Passer par ton vrai navigateur garantit la meilleure expérience.",
        powered_by: "Propulsé par QRISE",
        arrow_label: "ici !",
      },
      common: {
        save: "Enregistrer",
        cancel: "Annuler",
        delete: "Supprimer",
        edit: "Modifier",
        close: "Fermer",
        yes: "Oui",
        no: "Non",
        loading: "Chargement…",
        back: "Retour",
        not_found: "Introuvable",
        upload: "Téléverser",
      },
      rgpd: {
        eyebrow: "Contrat de sous-traitance RGPD",
        title: "Contrat RGPD entre QRISE et votre société",
        subtitle:
          "Merci de lire et d'accepter le contrat de traitement des données avant d'utiliser la plateforme. Vous pourrez le consulter à tout moment depuis votre profil.",
        open_link: "Contrat RGPD",
        checkbox_i_accept:
          "Je reconnais avoir lu, compris et accepté, au nom de {{client}}, les termes du présent contrat RGPD.",
        cta_accept: "Accepter le contrat",
        accepted_toast: "Contrat RGPD accepté — merci !",
        already_accepted_title: "Contrat déjà accepté",
        already_accepted_hint:
          "Accepté le {{date}} (version {{version}}). Ce document est archivé sur nos serveurs.",
        card_title: "Contrat RGPD de sous-traitance",
        card_hint:
          "Consultez à tout moment le contrat qui lie QRISE (SARL DEAL RUN) et votre société pour le traitement des données personnelles.",
        card_cta: "Voir le contrat",
        download_pdf: "Télécharger le PDF",
        th_column: "Contrat RGPD",
        accepted_on: "Accepté le",
        pending: "En attente",
      },
      poster: {
        tab_label: "Affiche",
        eyebrow: "Générateur d'affiche IA",
        title: "Créez votre affiche en un clic",
        subtitle:
          "Nano Banana Pro compose une affiche A4 premium pour votre concours en cours. Logo, QR code et lots sont insérés automatiquement — prête à imprimer.",
        game_label: "Jeu-concours",
        style_label: "Style visuel",
        cta_label: "Appel à l'action (bas d'affiche)",
        cta_hint: "60 caractères max. Apparaît juste sous le QR code.",
        generate_btn: "Générer mon affiche",
        regenerate_btn: "Régénérer",
        generating: "Création de votre affiche…",
        generating_hint:
          "~30-45 s. L'IA compose le visuel principal pendant que l'on ajoute le QR code et les lots.",
        generated_toast: "Affiche prête — aperçu à droite.",
        download: "Télécharger le PNG",
        print: "Imprimer",
        empty_title: "Votre affiche apparaîtra ici",
        empty_hint:
          "Choisissez un style, personnalisez l'appel à l'action puis cliquez sur Générer. Le jeu, les lots, le logo et le QR code sont repris automatiquement depuis votre jeu actif.",
      },
      rules: {
        title: "Règlement du jeu",
        subtitle:
          "Gérez les conditions générales que les participants peuvent consulter avant ou après avoir joué.",
        external_url: "URL externe",
        external_url_hint:
          "Si renseignée, un lien vers cette URL s'affiche sous le jeu.",
        content: "Contenu du règlement",
        placeholder:
          "Rédigez votre règlement en Markdown, ou générez un brouillon avec l'IA.",
        markdown_hint:
          "Markdown supporté (## Titres, **gras**, listes…)",
        generate: "Générer avec l'IA",
        generating: "Génération…",
        generated: "Règlement généré — relisez puis enregistrez",
        saved: "Règlement enregistré",
        view_btn: "Voir le règlement du jeu",
        edit_btn: "Règlement",
        manage: "Gérer le règlement",
      },
      grand_draw: {
        title: "Grand tirage au sort final",
        subtitle:
          "Les joueurs de ce jeu participent automatiquement à un grand tirage au sort à la fin de la campagne.",
        enable: "Activer le grand tirage final",
        enable_hint: "Les joueurs sont inscrits automatiquement dès qu'ils jouent.",
        winners_count: "Nombre de gagnants",
        eligibility: "Qui participe ?",
        eligibility_all: "Tous les joueurs (gagnants et perdants)",
        eligibility_losers: "Uniquement les perdants (seconde chance)",
        participants: "Participants inscrits",
        drawn_at: "Tirage effectué le {{date}}",
        draw_btn: "Tirer au sort",
        confirm_btn: "Confirmer — tirage définitif",
        cancel: "Annuler",
        drawing: "Tirage en cours…",
        draw_success: "Grand tirage effectué !",
        winners_title_one: "🏆 1 gagnant tiré au sort",
        winners_title_other: "🏆 {{count}} gagnants tirés au sort",
        definitive_note: "Un seul tirage possible — il est définitif.",
        done_note: "Le tirage est définitif et ne peut pas être refait.",
        no_participants: "Aucun participant pour le moment.",
        merchant_locked: "Réglages gérés par votre administrateur —",
      },
      lottery: {
        btn_draw: "Tirer au sort",
        dialog_title: "Tirage au sort",
        total_participants: "Participants",
        configured_winners: "Gagnants configurés",
        winners_to_draw: "Nombre de gagnants à tirer",
        draw_now: "Tirer maintenant",
        redraw: "Re-tirer",
        drawing: "Tirage en cours…",
        draw_success: "Tirage effectué !",
        winners_title_one: "🏆 1 gagnant sélectionné",
        winners_title_other: "🏆 {{count}} gagnants sélectionnés",
        tickets: "tickets",
        drawn_at: "Dernier tirage : {{date}}",
        distribute_now: "Distribuer les lots",
        distributing: "Distribution en cours…",
        distribute_success:
          "{{count}} gagnant(s) récompensé(s) — {{emails}} email(s) envoyé(s)",
        distribute_none:
          "Personne n'a tout pronostiqué juste — aucun lot distribué.",
        distributed_at: "Lots distribués : {{date}}",
        guaranteed_prize: "Lot garanti",
        rewarded_label: "Récompensés",
        emails_auto_note:
          "Chaque gagnant reçoit automatiquement un email avec son lien de récupération du lot.",
        email_sent: "Email envoyé",
        email_pending: "Email en attente",
        claim_until: "À récupérer avant le {{date}}",
      },
      profile: {
        title: "Profil",
        saved: "Profil enregistré",
        section_display: "Affichage",
        section_display_hint:
          "Affiché dans la plateforme QRISE pour votre compte.",
        section_legal: "Informations légales",
        section_pause: "Page d'attente (aucun jeu actif)",
        section_pause_hint:
          "Textes affichés sur votre lien QR permanent quand aucun jeu n'est en cours. Laissez un champ vide pour garder le texte par défaut.",
        pause_badge: "Badge (défaut : nom de l'enseigne)",
        pause_title: "Titre (défaut : « Le prochain jeu arrive bientôt »)",
        pause_body: "Texte (défaut : « … prépare une nouvelle expérience. Revenez dans quelques instants… »)",
        pause_status: "Libellé du statut (défaut : « En pause »)",
        section_legal_hint:
          "Utilisées par l'IA pour générer un règlement conforme. Gardez ces champs à jour.",
        name: "Nom du contact",
        company: "Nom commercial / marque",
        legal_name: "Raison sociale",
        address: "Adresse du siège",
        registration_number: "Numéro d'immatriculation (SIRET / RCS)",
        contact_email: "Email de contact",
        website: "Site web",
        logo: "Logo de l'enseigne",
        logo_hint:
          "Affiché sur chaque jeu que vous organisez. Format carré ou rond recommandé (PNG/JPG, max 2 Mo).",
      },
      bg: {
        label: "Image de fond",
        upload: "Téléverser",
        replace: "Remplacer",
        empty_hint: "Aucune image · cliquez pour téléverser",
        spec_hint:
          "Recommandé 1080×1920 portrait (9:16). Les images volumineuses sont redimensionnées et compressées automatiquement.",
        spec_hint_desktop:
          "Recommandé 1920×1080 paysage (16:9). Redimensionnée et compressée automatiquement.",
        spec_hint_tablet:
          "Recommandé 1536×2048 portrait (3:4). Redimensionnée et compressée automatiquement.",
        spec_hint_og:
          "Recommandé 1200×630. Affichée quand le lien du jeu est partagé (WhatsApp, Facebook…).",
        spec_hint_win:
          "GIF animé accepté. Affichée dans la pop-up de victoire au-dessus du message.",
        label_desktop: "Fond PC (par défaut)",
        label_tablet: "Fond Tablette",
        label_mobile: "Fond Mobile",
        responsive_title: "Images de fond par appareil",
        responsive_hint:
          "Le joueur voit automatiquement l'image adaptée à son écran. L'image PC sert de repli si aucune image tablette ou mobile n'est définie.",
        preview_title: "Aperçu joueur",
        preview_hint:
          "Rendu approximatif de la page de jeu publique avec vos fonds, couleurs et polices.",
        preview_fallback:
          "Image PC utilisée (aucun fond défini pour cet appareil).",
        device_desktop: "PC",
        device_tablet: "Tablette",
        device_mobile: "Mobile",
        too_large: "Image trop volumineuse (max {{mb}} Mo).",
        wrong_format: "Format non supporté. Utilisez JPG, PNG ou WebP.",
        process_error: "Impossible de traiter l'image.",
        uploaded: "Image téléversée",
      },
      qr: {
        title: "QR code du jeu",
        subtitle:
          "Imprimez-le ou scannez-le — les joueurs arrivent directement sur votre jeu.",
        copy_url: "Copier l'URL",
        copied: "Copié",
        copy_error: "Impossible de copier l'URL",
        download_success: "Téléchargé",
        print_hint:
          "PNG (1024 px) prêt à imprimer. SVG ré-échelonne à l'infini.",
      },
    },
  },
};

// Initial language detection order (first match wins):
//   1. Explicit user choice, persisted in localStorage under `qrise_lang`
//   2. Host-based default: .fr → fr (covers qrise-game.fr in prod + any
//      hosted .fr domain). This is critical for the public pages rendered
//      BEFORE we know the game's configured language — e.g. the in-app
//      browser warning screen, which appears before we fetch /api/public/games.
//   3. Falls back to "en" as the ultimate safety net.
function detectInitialLang() {
  if (typeof window === "undefined") return "en";
  const stored = localStorage.getItem("qrise_lang");
  if (stored === "fr" || stored === "en") return stored;
  // Browser language first: French browsers get FR, everyone else EN.
  const nav = window.navigator || {};
  const primary = ((nav.languages && nav.languages[0]) || nav.language || "").toLowerCase();
  if (primary) return primary.startsWith("fr") ? "fr" : "en";
  const host = (window.location && window.location.hostname) || "";
  if (/\.fr$/i.test(host) || /qrise-game/i.test(host)) return "fr";
  return "en";
}

function mergeDeep(target, src) {
  Object.entries(src).forEach(([k, v]) => {
    if (v && typeof v === "object") mergeDeep((target[k] = target[k] || {}), v);
    else target[k] = v;
  });
}
mergeDeep(resources.en.translation, accountResources.en);
mergeDeep(resources.fr.translation, accountResources.fr);
mergeDeep(resources.en.translation, rankResources.en);
mergeDeep(resources.fr.translation, rankResources.fr);

i18n.use(initReactI18next).init({
  resources,
  lng: detectInitialLang(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language;
  i18n.on("languageChanged", (l) => {
    document.documentElement.lang = l;
  });
}

export default i18n;
